<template>
    <b-card>
        <template v-if="preEmision">
            <div slot="header">
                <div class="text-center"><b-alert show variant="danger">Cuidado! Las Notas de Credito a Boletas emitidas hoy podran ser emitidas mañana</b-alert></div>
                <b-row>
                    <b-col>
                        <div class="text-center">
                            <b-col>
                                <h3 class="display-">Nota de Crédito Electrónica</h3>
                            </b-col>
                        </div>           
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" sm="6"	md="4"	lg="4"	xl="3">
                        <b-row align-v="center">
                            <b-col cols="4" sm="4"	md="4"	lg="4"	xl="4" class="text-right">
                                <label>Tipo:</label>
                            </b-col>
                            <b-col cols="8" sm="8"	md="8"	lg="8"	xl="8">
                                    <select class="custom-select mr-sm-2" v-model="tiponotacredito" :disabled="disabledTipoNC">
                                        <option :value="tipo.codigo" v-for="tipo in tiposNotaCredito" v-bind:key="tipo.codigo">
                                        {{ tipo.nombre }}
                                        </option>
                                    </select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                        <b-row class="text-center">
                            <b-col cols="4"	sm="4"	md="4"	lg="4"	xl="12"></b-col>
                            <b-col cols="8"	sm="8"	md="8"	lg="8"	xl="12">
                                <datepicker v-model="femision" :format="customFormatter" :language="es" :bootstrap-styling="true" :disabledDates="diasnopermitidos" :placeholder="currentdate"></datepicker>
                            </b-col>                           
                        </b-row>
                    </b-col>
                    <!-- Nueva nota de credito (Agregar items) -->
                    <b-col cols="12" sm="6"	md="4"	lg="3"	xl="5">
                        <b-row align-v="center"> 
                            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="4"></b-col>
                            <b-col v-if="switchitems" cols="12" sm="6"	md="4"	lg="4"	xl="4">
                                <b-row align-v="center">
                                    <b-col cols="4" class="text-right">
                                        <label>Moneda</label>
                                    </b-col>
                                    <b-col cols="8">
                                        <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="tipodemoneda" :disabled="monedaDisabled">
                                        <option :value="moneda" v-for="moneda in tipoMoneda" v-bind:key="moneda.id">
                                            {{ moneda.descripcion }}
                                        </option>
                                        </select>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col v-else cols="12" sm="6"	md="0"	lg="0"	xl="2"></b-col>
                            <b-col cols="12" sm="6"	md="8"	lg="10"	xl="3">
                                <b-button id="tooltipButton-1" size="sm" variant="outline-success" class="agregaritemsPersonalizado">
                                    <b-input-group>
                                        <b-row>
                                            <b-col cols="6" sm="6"	md="6"	lg="6"	xl="5">
                                                <label class="agregaritemsnew"><i class="fa fa-plus"></i> Items</label>
                                            </b-col>
                                            <b-col cols="4" sm="4"	md="4"	lg="6"	xl="4">
                                                <c-switch class="mx-1 cargaritemsPersonalizado" color="primary" v-model="switchitems" label outline="alt" variant="pill" v-bind="labelTxt" />
                                                <b-tooltip :show.sync="show" target="tooltipButton-1" placement="top">
                                                    <strong>NC a Boletas fisicas o emitidas en 2.0</strong>
                                                </b-tooltip>
                                            </b-col>
                                        </b-row>
                                    </b-input-group>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4"	lg="3"	xl="2">
                        <b-row>
                            <template>
                                <b-col> 
                                    <b-input-group>
                                        <template v-if="seriesCargadas">
                                            <b-button size="md" variant="secondary" outline-success>
                                                Cargando Series... <i class="fa fa-spin fa-spinner"></i>
                                            </b-button>
                                        </template>
                                        <template v-else>
                                            <select class="form-control input-placedark input-dark" v-model="indexSerie">
                                                <option v-for="(serie, index) in listaSeries" :value="index" :key="index">{{ serie }}</option>
                                            </select>
                                        </template>
                                        <!-- <button class="btn btn-warning btn-sm sinresultados2" @click="enableSeries"><i class="fa fa-exchange"></i></button> -->
                                    </b-input-group>
                                </b-col>
                            </template>                             
                        </b-row>                        
                    </b-col>
                </b-row>
            </div>
            <!-- Items Generales a todas las notas de credito -->
            <b-row>
                <b-col cols="12">
                    <template v-if="generalesNC">
                        <b-alert variant="secondary" show>
                            <b-row>
                                <b-col cols="4">
                                    <b-row v-if="!switchitems">
                                        <b-col cols="6">
                                            <b-form-group
                                                    label-for="input_serieAfectada"
                                                    :invalid-feedback="invalidFeedbackSerieAfectada"
                                                    :valid-feedback="validFeedbackSerieAfectada"
                                                    :state="stateSerieAfectada">
                                                    <b-input-group size="md" prepend="B">
                                                        <b-form-input :value="serieAfectada" @input="serieAfectada = $event.toUpperCase()" v-model="serieAfectada" maxlength="3" class="form-control input-requerido input-dark" type="text" id="input_serieAfectada" :state="state" placeholder="Serie Afectada(*)"></b-form-input>
                                                    </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="6">
                                            <input v-model="numeroAfectado" type="number" class="form-control input-requerido input-dark" required placeholder="Num. Afectado (*)">
                                        </b-col>
                                    </b-row>
                                    <b-row v-else>
                                        <b-col cols="12" sm="12" md="12" lg="12" xl="6">
                                            <input v-model="serieAfectada" maxlength="4" type="text" class="form-control  input-requerido input-dark" placeholder="Serie (*)">
                                        </b-col>
                                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="6">
                                            <input v-model="numeroAfectado" minlength="1" type="text" class="form-control input-requerido input-dark" placeholder="Numero (*)">
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col cols="8">
                                    <b-row>
                                        <b-col cols="1">
                                            <b-row align-h="center">
                                                <b-btn v-b-modal.modal1 v-b-tooltip.hover title="Vista Previa" @click="viewPdf()" disabled><i class="fa fa-tv"></i></b-btn>
                                                <b-modal id="modal1" size="lg" title="Vista Previa" cancel-title="Cerrar">
                                                    <template v-if="cargandopdf2"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
                                                    <template v-else>
                                                        <template v-if="pdfobject !==''">
                                                        <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
                                                        </template>
                                                    </template>
                                                </b-modal>
                                            </b-row>
                                        </b-col>
                                        <b-col cols="11">
                                            <input v-model="descripcionNC" type="text" class="form-control input-requerido input-dark" placeholder="Motivo para la Emision de la Nota de Crédito (*)">
                                            <small v-if="checkDescripcionNC" class="form-text text-muted"><span class="text-danger">{{ responseDescripcionNC }}</span></small>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <br>
                        </b-alert>
                    </template>
                </b-col>
            </b-row>
            <!-- Fin de los Generales a todas las notas de credito -->
            <template v-if="!switchitems">
                <!-- Nota de credito tipo "Anulacion de la Operacion" = 01 -->
                <template v-if="tiponotacredito == '01'">
                    <b-row align-v="center">
                        <b-col cols="12">
                            <template v-if="!switchitems">
                                <b-row>
                                    <b-col cols="5"></b-col>
                                    <b-col cols="1">
                                        <template v-if="validateCreditNote()">
                                            <button v-if="!cargandoemisionCaso1" class="btn btn-primary botonesemitir" @click="searchTicket()"><i class="fa fa-location-arrow"></i> Previsualizar</button>
                                            <button v-else class="btn btn-seconday botonesemitir"><i class="fa fa-spin fa-spinner"></i> Buscando</button>
                                        </template>
                                        <template v-else>
                                            <button class="btn btn-secondary botonesemitir" disabled><i class="fa fa-send"></i> Previsualizar</button>  <!--principal -->
                                        </template>
                                    </b-col>
                                    <b-col cols="6"></b-col>
                                </b-row>
                            </template>
                        </b-col>
                    </b-row>
                </template>
                <!-- Nota de credito "Devolucion Total" = 06 -->
                <template v-if="tiponotacredito == '06'">
                    <b-row class="row text-center">
                        <b-col class="col-md-12">
                            <template v-if="validateCreditNote()">
                                    <button v-if="!cargandoemisionCaso6" class="btn btn-primary" @click="searchTicket()"><i class="fa fa-location-arrow"></i> Previsualizar</button>
                                    <button v-else class="btn btn-seconday"><i class="fa fa-spin fa-spinner"></i> Buscando</button>
                            </template>
                            <template v-else>
                                <button class="btn btn-secondary" disabled><i class="fa fa-send"></i> Previsualizar</button>
                            </template>
                        </b-col>
                    </b-row>
                </template>
                <!-- Fin de nota de credito 06 -->
                <!-- Nota de credito "Descuento Global" = 04 -->
                <template v-else-if="tiponotacredito == '04'">
                    <br>
                    <b-row align-v="center">
                    <b-col cols="12" sm="4"	md="3"	lg="2"	xl="1"></b-col>    
                    <b-col cols="12" sm="4"	md="3"	lg="2"	xl="2">
                    <input v-if="!vunitario" v-model="precioVentaUnitario" class="form-control input-requerido input-dark" placeholder="Monto (IGV)" required/>
                    <b-form-input v-else v-model="precioVentaUnitario" class="form-control" placeholder="Precio Unitario (con IGV)" required disabled/>
                    <small v-if="checkprecioventaunitario" class="form-text text-muted"><span class="text-danger">{{ responsecheckprecioventaunitario }}</span></small>
                    </b-col>
                    <b-col cols="12" sm="4"	md="3"	lg="2"	xl="2">
                    <input v-if="vunitario" type="text" min="0.0" step="0.01" v-model.number="valorUnitario" class="form-control input-placedark input-dark" placeholder="Valor (Sin IGV)" required/>
                    <b-form-input v-else type="number" min="0.0" step="0.01" v-model="valorUnitario" class="form-control input-placedark input-dark" placeholder="Valor (Sin IGV)" required disabled/>
                    <small v-if="checkvalorunitario" class="form-text text-muted"><span class="text-danger">{{ responsecheckvalorunitario }}</span></small>
                    </b-col>
                    <b-col cols="12" sm="6"	md="3"	lg="2"	xl="2">
                    <b-form-input v-if="tipoOperacion == '0200'" disabled value="Exportación"></b-form-input>
                    <select v-else class="custom-select mr-sm-2 input-placedark input-dark" v-model="especificacionIgv">
                        <option :value="afec.id" v-for="afec in listaafectacion" v-bind:key="afec.id">
                        {{ afec.descripcion }}
                        </option>
                    </select>
                    </b-col>
                    <b-col v-if="!ventaGratuita" cols="12" sm="6"	md="3"	lg="3"	xl="2">
                    <b-form-input disabled value="Operación Onerosa"></b-form-input>
                    </b-col>
                    <b-col v-else cols="12" sm="6"	md="3"	lg="3"	xl="2">
                    <b-form-input v-if="tipoOperacion == '0200'" disabled value="Bienes"></b-form-input>
                    <select v-else class="custom-select mr-sm-2 input-placedark input-dark" v-model="especificacion">
                        <option :value="espec" v-for="espec in Especificacion" v-bind:key="espec.id">
                        {{ espec.descripcion }}
                        </option>
                    </select>
                    </b-col>
                    </b-row>
                    <br>
                    <div class="text-center">
                        <template v-if="!ValidateCaso4()">
                            <button class="btn btn-secondary" disabled><i class="fa fa-location-arrow"></i> Previsualizar</button>
                        </template>
                        <template v-else>
                            <button v-if="!cargandoemisionCaso4" class="btn btn-primary" @click="searchTicket()"><i class="fa fa-location-arrow"></i> Previsualizar</button>
                            <button v-else class="btn btn-secondary" disabled><i class="fa fa-spin fa-spinner"></i> Buscando</button>
                        </template>
                    </div>
                </template>
                <!-- Fin de nota de credito 04 -->
                <!-- Notas de credito similares ("Correccion por error en la descripcion" = 03) ("Descuento por item" = 05) ("Devolucion parcial" = 07) -->
                <template v-else-if="tiponotacredito == '03' || tiponotacredito == '05' || tiponotacredito == '07'">
                    <template v-if="descuentoItemSiguiente">
                        <b-row>
                            <b-col cols="6">
                                <b-card border-variant="light"
                                    class="text-center">
                                    <template slot="header">
                                        <b-row align-v="center">
                                            <b-col cols="4"></b-col>
                                            <b-col cols="4">
                                                <h6>Items de la Factura</h6>
                                            </b-col>
                                            <b-col cols="4">
                                            </b-col>
                                        </b-row>
                                    </template>
                                    <b-row>
                                        <b-col cols="12">
                                            <!-- Nota de credito "Descuento por item" = 05 -->
                                            <template v-if="tiponotacredito == '05'">
                                                <table class="table table-boreder">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 5%">Cantidad</th>
                                                            <th style="width: 40%">Descripcion</th>
                                                            <th style="width: 15%">P. Unitario</th>
                                                            <th style="width: 15%">Desc. Unit. incl. Igv</th>
                                                            <th style="width: 15%">P. Venta</th>
                                                            <th style="width: 10%">Acciones</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in listaNotaCredito" :key="index">
                                                            <td>{{ item.cantidad }}</td>
                                                            <td>{{ item.descripcion }}</td>
                                                            <td>{{ item.precioVentaUnitario }}</td>
                                                            <td><b-input class="descuento text-center" v-model="item.descuento"></b-input></td>
                                                            <td>{{ item.precioVentaUnitario*item.cantidad }}</td>
                                                            <td>
                                                                <button class="btn btn-sm btn-group btn-outline-info" @click.prevent="setrowCaso5(item, index)"><i class="fa fa-plus"></i></button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </template>
                                            <!-- Fin de nota de credito 05 -->
                                            <template v-else-if="tiponotacredito == '07'">
                                                <table class="table table-boreder">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 5%">Cantidad</th>
                                                            <th style="width: 15%">Descontar Cant. Prod.</th>
                                                            <th style="width: 40%">Descripcion</th>
                                                            <th style="width: 15%">V. Unitario</th>
                                                            <th style="width: 15%">V. Venta</th>
                                                            <th style="width: 10%">Acciones</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in listaNotaCredito" :key="index">
                                                            <td>{{ item.cantidad }}</td>
                                                            <td><b-input class="descuento text-center" v-model="item.descontarCantidad"></b-input></td>
                                                            <td>{{ item.descripcion }}</td>
                                                            <td>{{ item.valorUnitario }}</td>
                                                            <td>{{ item.valorVenta }}</td>
                                                            <td>
                                                                <button class="btn btn-sm btn-group btn-outline-info" @click.prevent="setrowCaso357(item, index)"><i class="fa fa-plus"></i></button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </template>
                                            <template v-else-if="tiponotacredito == '03'">
                                                <table class="table table-boreder">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 5%">Cantidad</th>
                                                            <th style="width: 40%">Descripcion</th>
                                                            <!-- <th style="width: 15%">Cambiar Descripcion</th> -->
                                                            <th style="width: 15%">V. Unitario</th>
                                                            <th style="width: 15%">V. Venta</th>
                                                            <th style="width: 10%">Acciones</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in listaNotaCredito" :key="index">
                                                            <td>{{ item.cantidad }}</td>
                                                            <td>{{ item.descripcion }}</td>
                                                            <!--<td><b-input class="descuento text-center" v-model="item.cambiarDescripcion"></b-input></td>-->
                                                            <td>{{ item.valorUnitario }}</td>
                                                            <td>{{ item.valorVenta }}</td>
                                                            <td>
                                                                <button class="btn btn-sm btn-group btn-outline-info" v-b-modal.caso3 @click.prevent="setrowCasoTres(item, index)"><i class="fa fa-plus"></i></button>
                                                            </td>
                                                        </tr>
                                                            <b-modal id="caso3" centered title="Correccion por error en la descripción" size="lg" v-model="previaEmisionCaso3">
                                                        Dice: <b-form-textarea id="textarea" rows="3" max-rows="6" v-model="descrip" disabled></b-form-textarea>
                                                        Debe decir: <b-form-input type="text" v-model="cambiarDescripcionn"></b-form-input>
                                                        <b-form-text style="font-size: small !important; color: #ea0909 !important">Ingresa una nueva descripción</b-form-text>
                                                        <div slot="modal-footer" class="w-100">
                                                            <b-btn v-if="!validateSendCaso3" size="sm" class="float-right" variant="primary" @click="setrowCaso3()">
                                                            Enviar
                                                            </b-btn>
                                                            <b-btn v-else size="sm" class="float-right" variant="secondary">
                                                            <i class="fa fa-spin fa-spinner"></i> Enviando...
                                                            </b-btn>
                                                        </div>
                                                    </b-modal>
                                                    </tbody>
                                                </table>
                                            </template>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </b-col>
                            <b-col cols="6">
                                <b-card border-variant="light"
                                    header="Items Afectados"
                                    class="text-center">
                                    <b-row>
                                        <b-col cols="12" v-if="tiponotacredito == '05'">
                                            <table class="table table-boreder">
                                                <thead>
                                                    <tr>
                                                        <th>Cantidad</th>
                                                        <th>Descripcion</th>
                                                        <th>Precio Unitario</th>
                                                        <th>Valor Venta</th>
                                                        <th>Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in listaNotaCreditoAfectada" :key="index">
                                                        <td>{{ item.cantidad }}</td>
                                                        <td>{{ item.descripcion }}</td>
                                                        <td>{{ item.descuento }}</td>
                                                        <td>{{ item.descuento*item.cantidad }}</td>
                                                        <td>
                                                            <button class="btn btn-sm btn-group btn-outline-danger" @click.prevent="deleteItem(item, index)"><i class="fa fa-trash danger"></i></button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </b-col>
                                        <b-col cols="12" v-else>
                                            <table class="table table-boreder">
                                                <thead>
                                                    <tr>
                                                        <th>Cantidad</th>
                                                        <th>Descripcion</th>
                                                        <th>Valor Unitario</th>
                                                        <th>Valor Venta</th>
                                                        <th>Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in listaNotaCreditoAfectada" :key="`item-${index}`">
                                                        <td>{{ item.cantidad }}</td>
                                                        <td>{{ item.descripcion }}</td>
                                                        <td>{{ item.valorUnitario }}</td>
                                                        <td>{{ item.valorVenta }}</td>
                                                        <td>
                                                            <button class="btn btn-sm btn-group btn-outline-danger" @click.prevent="deleteItem(item, index)"><i class="fa fa-trash danger"></i></button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </b-col>
                                    </b-row>
                                    <div class="row">
                                        <b-col cols="12" sm="12"	md="6"	lg="5"	xl="12">
                                            <b-row>
                                                <b-col>
                                                    <div class="text-center">
                                                        <strong>TOTALES</strong>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                            <hr>
                                            <b-row>
                                                <b-col cols="6" sm="6"	md="6"	lg="6"	xl="6">
                                                    <div class="text-right"><strong>IGV:</strong></div>
                                                    <div class="text-right"><strong>Venta Gravada:</strong></div>
                                                    <div class="text-right"><strong>Venta Exonerada:</strong></div>
                                                    <div class="text-right"><strong>Venta Inafecta:</strong></div>
                                                    <div class="text-right"><strong>Venta:</strong></div>
                                                </b-col>
                                                <b-col cols="2" sm="2"	md="2"	lg="2"	xl="2">
                                                    <div>
                                                        {{ moneda.simbolo }}
                                                    </div>
                                                    <div>
                                                        {{ moneda.simbolo }}
                                                    </div>
                                                    <div>
                                                        {{ moneda.simbolo }}
                                                    </div>
                                                    <div>
                                                        {{ moneda.simbolo }}
                                                    </div>
                                                    <div>
                                                        {{ moneda.simbolo }}
                                                    </div>
                                                </b-col>
                                                <b-col cols="4" sm="4"	md="4"	lg="4"	xl="4">
                                                    <div class="alineacionTotales">
                                                        {{ accumulateIgv() }}
                                                    </div>
                                                    <div class="alineacionTotales">
                                                        {{ accumulateRecordedSale() }}
                                                    </div>
                                                    <div class="alineacionTotales">
                                                        {{ accumulateExoneratedSale() }}
                                                    </div>
                                                    <div class="alineacionTotales">
                                                        {{ accumulateUnaffectedSale() }}
                                                    </div>
                                                    <div class="alineacionTotales">
                                                        {{ accumulateTotalSale() }}
                                                    </div>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </div>
                                </b-card>
                            </b-col>
                        </b-row>
                    </template>
                    <template>
                        <b-row>
                            <b-col cols="5"></b-col>
                            <b-col cols="4">
                                <template v-if="validateCreditNote()">
                                        <template v-if="listaNotaCreditoAfectada.length == 0 && listaNotaCredito.length == 0">
                                            <template v-if="tiponotacredito == '03'">
                                                <button v-if="!cargandoemisionCaso3" class="btn btn-primary" @click="searchTicket()"><i class="fa fa-location-arrow"></i> Siguiente</button>
                                                <button v-else class="btn btn-seconday"><i class="fa fa-spin fa-spinner"></i> Cargando...</button>
                                            </template>
                                            <template v-else-if="tiponotacredito == '05'">
                                                <button v-if="!cargandoemisionCaso5" class="btn btn-primary" @click="searchTicket()"><i class="fa fa-location-arrow"></i> Siguiente</button>
                                                <button v-else class="btn btn-seconday"><i class="fa fa-spin fa-spinner"></i> Cargando...</button>
                                            </template>
                                            <template v-else-if="tiponotacredito == '06'">
                                                <button v-if="!cargandoemisionCaso6" class="btn btn-primary" @click="searchInvoice()"><i class="fa fa-location-arrow"></i> Siguiente</button>
                                                <button v-else class="btn btn-seconday"><i class="fa fa-spin fa-spinner"></i> Cargando...</button>
                                            </template>
                                            <template v-else-if="tiponotacredito == '07'">
                                                <button v-if="!cargandoemisionCaso7" class="btn btn-primary" @click="searchTicket()"><i class="fa fa-location-arrow"></i> Siguiente</button>
                                                <button v-else class="btn btn-seconday"><i class="fa fa-spin fa-spinner"></i> Cargando...</button>
                                            </template>
                                        </template>
                                        <template v-if="listaNotaCredito.length > 0 || listaNotaCreditoAfectada.length > 0">
                                            <template v-if="tiponotacredito == '03'">
                                                <template v-if="!caso3Emitir">
                                                    <button class="btn btn-secondary" disabled><i class="fa fa-location-arrow"></i> Previsualizar</button>
                                                </template>
                                                <template v-else>
                                                    <button v-if="!emitiendo" class="btn btn-primary" @click="sendNoteCredit()"><i class="fa fa-location-arrow"></i> Previsualizar</button>
                                                    <button v-else class="btn btn-secondary" disabled><i class="fa fa-spin fa-spinner"></i> Buscando</button>
                                                </template>
                                            </template>
                                            <template v-if="tiponotacredito == '05'">
                                                <template v-if="!caso5Emitir">
                                                    <button class="btn btn-secondary" disabled><i class="fa fa-location-arrow"></i> Previsualizar</button>
                                                </template>
                                                <template v-else>
                                                    <button v-if="!emitiendo" class="btn btn-primary" @click="sendNoteCredit()"><i class="fa fa-location-arrow"></i> Previsualizar</button>
                                                    <button v-else class="btn btn-secondary" disabled><i class="fa fa-spin fa-spinner"></i> Buscando</button>
                                                </template>
                                            </template>
                                            <template v-if="tiponotacredito == '07'">
                                                <template v-if="!caso7Emitir">
                                                    <button class="btn btn-secondary" disabled><i class="fa fa-location-arrow"></i> Previsualizar</button>
                                                </template>
                                                <template v-else>
                                                    <button v-if="!emitiendo" class="btn btn-primary" @click="sendNoteCredit()"><i class="fa fa-location-arrow"></i> Previsualizar</button>
                                                    <button v-else class="btn btn-secondary" disabled><i class="fa fa-spin fa-spinner"></i> Buscando</button>
                                                </template>
                                            </template>
                                        </template>
                                </template>
                                <template v-else>
                                    <button class="btn btn-secondary" disabled><i class="fa fa-send"></i> Siguiente</button>
                                </template>
                            </b-col>
                        </b-row>
                    </template>
                </template>
                <!-- Fin de notas de credito 03, 05, 07 -->
                 <!-- INICIO NC TIPO 13 -->
            <template v-if="tiponotacredito == '13'">
                <b-card v-if="mostrarPreviaCreditos">
                    <b-row>
                        <b-col cols="6">
                            <b-alert class="text-center pb-3" show>CUOTAS ACTUALES</b-alert>
                            <b-table :items="ncCredito" fixed outlined></b-table>
                        </b-col>
                    <b-col cols="6">
                        <b-row>
                            <b-col cols="12">
                                <b-alert class="text-center pb-2" show>NUEVAS CUOTAS <b-button @click="modalCuotas()" size="sm" variant="primary"><i class="fas fa-plus"></i></b-button></b-alert>
                                <b-table :items="cuotasCredito" :fields="cuotas_credito" fixed outlined>
                                    <template slot="acciones" slot-scope="row">
                                        <b-button variant="outline-danger" style="border:none"  size="sm" @click="deletecuota(row.index)"><i class="fas fa-trash"></i></b-button>
                                    </template>
                                </b-table>                                 
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="6">
                               <b-alert show><h5>Total Crédito : {{totalcredito}}</h5></b-alert>
                            </b-col>
                            <b-col cols="6">
                                <b-alert show><h5>Total Factura : {{ moneda.simbolo }}{{importeTotalCuota}} </h5></b-alert>
                            </b-col>
                        </b-row>
                         <hr>
                        <b-row>
                            <b-col cols="6" sm="6"	md="6"	lg="6"	xl="6">
                                <div class="text-right"><strong>IGV:</strong></div>
                                <div class="text-right"><strong>Venta Gravada:</strong></div>
                                <div class="text-right"><strong>Venta Exonerada:</strong></div>
                                <div class="text-right"><strong>Venta Inafecta:</strong></div>
                                <div class="text-right"><strong>Venta Gratuita:</strong></div>
                                <div class="text-right"><strong>Venta Exportación:</strong></div>
                                <div class="text-right"><strong>Venta:</strong></div>
                            </b-col>
                            <b-col cols="2" sm="2"	md="2"	lg="2"	xl="2">
                                <div>
                                    {{ moneda.simbolo }}
                                </div>
                                <div>
                                    {{ moneda.simbolo }}
                                </div>
                                <div>
                                    {{ moneda.simbolo }}
                                </div>
                                <div>
                                    {{ moneda.simbolo }}
                                </div>
                                <div>
                                    {{ moneda.simbolo }}
                                </div>
                                <div>
                                    {{ moneda.simbolo }}
                                </div>
                                <div>
                                    {{ moneda.simbolo }}
                                </div>
                            </b-col>
                            <b-col cols="4" sm="4"	md="4"	lg="4"	xl="4">
                                <div class="alineacionTotales">
                                    {{ accumulateIgv() }}
                                </div>
                                <div class="alineacionTotales">
                                    {{ accumulateRecordedSale() }}
                                </div>
                                <div class="alineacionTotales">
                                    {{ accumulateExoneratedSale() }}
                                </div>
                                <div class="alineacionTotales">
                                    {{ accumulateUnaffectedSale() }}
                                </div>
                                <div class="alineacionTotales">
                                    {{ accumulateFreeSale() }}
                                </div>
                                <div class="alineacionTotales">
                                    {{ accumulateExportSale() }}
                                </div>
                                <div class="alineacionTotales">
                                    {{ accumulateTotalSale() }}
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>                                        
                <!-- MODAL FORMA DE PAGO CREDITO -->
                    <b-modal size="lg" v-model="modalCredito">
                    <b-row class="mb-2">
                        <b-col cols="4">
                        <datepicker class="input-placedark input-dark"
                            v-model="fechaPagoCuota"
                            :language="es"
                            :format="customFormatter"
                            :bootstrap-styling="true"
                            placeholder="Fecha de Vencimiento"
                        ></datepicker>
                        </b-col>
                        <b-col cols="4">
                        <b-input class="text-center"
                            type="number"
                            v-model="montoPagoCuota"
                            @keyup.enter='addcuota()'
                            placeholder="Monto cuota"
                        ></b-input>
                        </b-col>
                        <b-col>
                        <b-button class="mt-1" variant="primary" size="sm" v-model="idencredito" :disabled="validarcredito" @click="addcuota()"><i class="fas fa-plus"></i></b-button>
                        </b-col>
                    </b-row>
                        <template slot="modal-header">
                            <div style="width:20%">
                            <h4>Cuotas Crédito</h4>
                            </div>   
                            <div style="text-align:right;width:40%">
                            <h4>Total Factura:</h4>
                            </div>
                            <div style="width:39%">
                            <h4  style="color:red">{{ moneda.simbolo }}{{importeTotalCuota}}</h4>
                            </div>  
                        </template>
                        <b-table
                            :outlined="outlined"
                            small   
                            :items="cuotasCredito" 
                            :fields="cuotas_credito">
                            <template slot="acciones" slot-scope="row">
                                <b-button variant="outline-danger" style="border:none"  size="sm" @click="deletecuota(row.index)"><i class="fas fa-trash"></i></b-button>
                            </template>
                        </b-table>
                        <template>
                            <div slot="modal-footer" class="w-100">
                                <b-row>
                                <b-col cols="12" sm="12" md="10" lg="10" xl="10" >  
                                <div style="color:">
                                    <h5>Total Credito : {{totalcredito}}</h5>
                                </div>
                                </b-col>
                                <b-col cols="12" sm="12" md="2" lg="2" xl="2">
                                <b-button variant="primary" @click="modalcredito()">Cerrar</b-button>
                                </b-col>
                            </b-row>
                            </div> 
                        </template>
                    </b-modal>
                    <!-- FIN MODAL FORMA DE PAGO CREDITO -->
                 </b-card>
                <b-row align-v="center">
                    <b-col cols="12">
                        <template v-if="previatipo13">
                            <b-row>
                                <b-col cols="5"></b-col>
                                <b-col cols="1">
                                    <template v-if="validateCreditNote()">
                                        <button v-if="!cargandoemisionCaso13" class="btn btn-primary botonesemitir" @click="searchTicket()"><i class="fa fa-location-arrow"></i> Siguiente</button>
                                        <button v-else class="btn btn-seconday botonesemitir"><i class="fa fa-spin fa-spinner"></i> Buscando</button>
                                    </template>
                                    <template v-else>
                                        <button class="btn btn-secondary botonesemitir" disabled><i class="fa fa-send"></i> Siguiente</button>
                                    </template>
                                </b-col>
                                <b-col cols="6"></b-col>
                            </b-row>
                        </template>
                        <template v-else>
                            <b-row>
                                <b-col cols="5"></b-col>
                                <b-col cols="2">
                                    <b-button v-if="mostrarPreviaCreditos" :disabled="cuotasCredito < 1" @click="sendNoteCredit()" variant="primary"> <i class="fa fa-location-arrow"></i> Previsualizar</b-button>
                                    <b-button v-else disabled>Previsualizar</b-button>
                                </b-col>
                                <b-col cols="5"></b-col>
                            </b-row>
                       </template>
                    </b-col>
                </b-row>
            </template>
            <!-- FIN NC TIPO 13 -->
                <template v-else-if="tiponotacredito == '06'">
                    <h4>Proximamente...</h4>
                </template>
            </template>
            <template v-else>  
                <b-row>
                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">        
                        <b-row>                       
                            <b-col cols="12" sm="6"	md="4"	lg="3"	xl="2">
                                <select class="custom-select mr-sm-2 input-placedark input-dark" id="inlineFormCustomSelect" v-model="tipoDocumento">                       
                                    <option :value="tipodocumento.tipo" v-for="tipodocumento in documentosIdentidad" v-bind:key="tipodocumento.tipo">
                                        {{ tipodocumento.nombre }}
                                    </option>
                                </select> 
                            </b-col>
                            <b-col cols="12" sm="6"	md="4"	lg="3"	xl="2">
                                <template v-if="tipoDocumento != 0">
                                    <b-input-group>
                                        <b-form-input class="input-placedark input-dark" placeholder="Buscar..." :maxlength="logitudDoc" v-model="CreditNote.receptor.nro" @change="getReceivers"></b-form-input>
                                        <b-input-group-text slot="append">
                                            <button class="btn btn-warning btn-sm sinresultados" @click="enableFieldsReceptor"><i class="fa fa-plus"></i></button>
                                        </b-input-group-text>
                                    </b-input-group>
                                    <template v-if="cargandoreceptor">
                                            <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item> 
                                    </template>
                                    <b-list-group v-if="listarec" class="searcher-field">
                                        <b-list-group-item v-if="norec">No hay Receptores con ese número</b-list-group-item>                                 
                                        <template v-for="(item, index) in listaReceptores">
                                            <b-list-group-item :key="index" @click="setReceiver(item)" class="searcher-result">{{item.idReceptor + ' - ' + item.razonSocial}}</b-list-group-item>
                                        </template>
                                    </b-list-group>  
                                </template>
                                <template v-else>
                                    <b-form-input disabled></b-form-input>                          
                                </template>         
                            </b-col>
                            <b-col cols="12" sm="6"	md="4"	lg="3"	xl="3" v-if="tipoDocumento != '0'"><b-form-input class="input-placedark input-dark" size="md" type="text" v-model="CreditNote.receptor.razonSocial" :value="CreditNote.receptor.razonSocial" :readonly="habilitado" placeholder="Razón Social"></b-form-input></b-col>
                            <b-col cols="12" sm="6"	md="4"	lg="3"	xl="3" v-else><b-input placeholder="Público en General" disabled></b-input></b-col>
                            <b-col cols="12" sm="12"	md="10"	lg="6"	xl=5>
                                <b-row>
                                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12" v-if="tipoDocumento != '0'"><b-form-input class="input-placedark input-dark" size="md" type="text" v-model="CreditNote.receptor.direccionFiscal" :value="CreditNote.receptor.direccionFiscal" :readonly="habilitado" placeholder="Dirección"></b-form-input></b-col>   
                                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12" v-else><b-input placeholder="Direccion General" disabled></b-input></b-col>   
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row><br>
                <b-row>
                    <b-col cols="12" sm="6"	md="4"	lg="3"	xl="1">
                        <b-form-input v-model="cantidad" class="form-control input-dark" placeholder="Cantidad (*)" required/>
                        <small v-if="checkcantidad" class="form-text text-muted"><span class="text-danger">{{ responsecheckcantidad }}</span></small>            
                    </b-col>
                    <b-col cols="12" sm="6"	md="4"	lg="3"	xl="2">
                        <select class="custom-select mr-sm-2 input-placedark input-dark" id="inlineFormCustomSelect" v-model="unidadMedidaCantidad">                       
                            <option :value="unidad.codigo" v-for="unidad in unidades" v-bind:key="unidad.id">
                                {{ unidad.descripcion }}
                            </option>
                        </select>                    
                    </b-col>
                    <b-col cols="12" sm="6"	md="4"	lg="3"	xl="1">
                        <b-input-group>
                        <b-form-input class="input-placedark input-dark" placeholder="C. Prod." maxlength="30" v-model="codigoProducto" @change="getReceiversProductCode"></b-form-input>
                        </b-input-group>
                        <template v-if="cargandoCodBarras">
                            <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item> 
                        </template>
                        <b-list-group v-if="listarecProduct" class="searcher-field">
                        <b-list-group-item v-if="norecProduct">No hay codigos con ese numero</b-list-group-item>                                 
                        <template v-for="(item, index) in listaReceptoresProductCode">
                            <b-list-group-item :key="index" @click="setReceiverProductCode(item)" class="searcher-result">{{item.codigo + ' - ' + item.descripcion}}</b-list-group-item>
                        </template>
                        </b-list-group>                            
                    </b-col>
                    <b-col cols="12" sm="6"	md="4"	lg="3"	xl="1">
                        <b-input-group>
                        <b-form-input :placeholder="placeholdercodigo" maxlength="8" v-model="codigoSunatBarras" @change="getReceiversCodeBarrasSunat" class="input-requerido"></b-form-input>
                        </b-input-group>
                        <template v-if="cargandoBarrasSunat">
                            <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item> 
                        </template>
                        <b-list-group v-if="listarecProductBarrasSunat" class="searcher-field input-placedark input-dark">
                        <b-list-group-item v-if="norecProductBarrasSunat">No hay codigos con ese numero</b-list-group-item>                                 
                        <template v-for="(item, index) in listaReceptoresCodeBarrasSunat">
                            <b-list-group-item :key="index" @click="setReceiverCodeBarrasSunat(item)" class="searcher-result">{{item.codigo + ' - ' + item.descripcion}}</b-list-group-item>
                        </template>
                        </b-list-group>                            
                    </b-col>
                    <b-col cols="12" sm="12"	md="8"	lg="12"	xl="7">
                        <b-input-group>
                            <b-form-input placeholder="Descripcion (*)" maxlength="500" v-model="descripcion" @input="getReceiversDescription" class="input-requerido input-dark" type="text"></b-form-input>
                            <b-input-group-text slot="append">
                                <button class="btn btn-warning btn-sm sinresultados" @click="cerrarresultados"><i class="fa fa-times"></i></button>
                            </b-input-group-text>
                        </b-input-group>
                        <template v-if="loadDescription">
                            <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item> 
                        </template>
                        <b-list-group v-if="listades" class="searcher-field">
                        <b-list-group-item v-if="nodescription">No hay productos con ese nombre</b-list-group-item>                                 
                        <template v-for="(item, index) in listaDescription">
                            <b-list-group-item :key="index" @click="setReceiverDescription(item)" class="searcher-result">{{item.codigo + ' - ' + item.descripcion + ' --- Precio: ' + item.precioUnitario}}</b-list-group-item>
                        </template>
                        </b-list-group>                            
                    </b-col>
                </b-row><br>
                <b-row>   
                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="9">
                        <b-row>
                            <b-col cols="12" sm="4"	md="3"	lg="2"	xl="2">
                                <b-form-input v-if="!vunitario" v-model="precioVentaUnitario" class="form-control input-requerido input-dark" placeholder="Precio Unitario (con IGV)" @keyup.enter="addItem()" required/>
                                <b-form-input v-else v-model="precioVentaUnitario" class="form-control" placeholder="Precio Unitario (con IGV)" required disabled/>
                                <small v-if="checkprecioventaunitario" class="form-text text-muted"><span class="text-danger">{{ responsecheckprecioventaunitario }}</span></small>
                            </b-col>
                            <b-col cols="12" sm="4"	md="3"	lg="2"	xl="2">
                                <b-form-input v-if="vunitario" type="number" min="0.0" step="0.01" v-model="valorUnitario" class="form-control input-placedark input-dark" placeholder="Valor Unitario (Sin IGV)" required/>
                                <b-form-input v-else type="number" min="0.0" step="0.01" v-model="valorUnitario" class="form-control input-placedark input-dark" placeholder="Valor Unitario (Sin IGV)" required disabled/>
                                <small v-if="checkvalorunitario" class="form-text text-muted"><span class="text-danger">{{ responsecheckvalorunitario }}</span></small>
                            </b-col>
                            <b-col cols="12" sm="4"	md="3"	lg="3"	xl="3">
                                <b-row>
                                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4" class="botondescuento">
                                        <b-form-checkbox v-model="descuento">Dscto</b-form-checkbox>
                                    </b-col>
                                    <b-col cols="12" sm="8"	md="8"	lg="8"	xl="8" v-if="!descuento">
                                        <b-row>
                                            <b-col cols="12" class="checkdescuentoitem">
                                                <b-input-group size="xs" prepend="S/.">
                                                    <b-form-input v-model="descuentoItemMonto"></b-form-input>
                                                </b-input-group>
                                            </b-col>        
                                        </b-row>
                                    </b-col>
                                    <b-col cols="12" sm="8"	md="8"	lg="8"	xl="8" v-else>
                                        <b-row>
                                            <b-col cols="12" class="checkdescuentoitem">
                                                <b-input-group size="xs" append="%">
                                                    <b-form-input v-model="descuentoItemPorcentaje"></b-form-input>
                                                </b-input-group>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col cols="12" sm="6"	md="3"	lg="2"	xl="2">
                                <b-form-input v-if="tipoOperacion == '0200'" disabled value="Exportación"></b-form-input>
                                <select v-else class="custom-select mr-sm-2 input-placedark input-dark" v-model="especificacionIgv">
                                    <option :value="afec.id" v-for="afec in listaafectacion" v-bind:key="afec.id">
                                        {{ afec.descripcion }}
                                    </option>
                                </select>
                            </b-col>
                            <b-col v-if="!ventaGratuita" cols="12" sm="6"	md="3"	lg="3"	xl="3">
                                <b-form-input disabled value="Operación Onerosa"></b-form-input>
                            </b-col>
                            <b-col v-else cols="12" sm="6"	md="3"	lg="3"	xl="3">
                                <b-form-input v-if="tipoOperacion == '0200'" disabled value="Bienes"></b-form-input>
                                <select v-else class="custom-select mr-sm-2 input-placedark input-dark" v-model="especificacion">
                                    <option :value="espec" v-for="espec in Especificacion" v-bind:key="espec.id">
                                        {{ espec.descripcion }}
                                    </option>
                                </select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" sm="12" md="12" lg="12" xl="3">    
                        <b-card class="adicionalesOperacionItem">
                            <span class="titulo-opitem"><strong> Operaciones Adicionales </strong></span>
                            <br>
                            <b-form-checkbox v-model="vunitario">
                                Usar valor unitario
                            </b-form-checkbox>
                            <b-form-checkbox v-model="servicio">
                                    Servicio
                            </b-form-checkbox>
                            <b-form-checkbox v-model="vbarras">
                                    C. Barras
                            </b-form-checkbox>
                            <b-form-checkbox v-model="ventaGratuita">
                                    Venta Gratuita
                            </b-form-checkbox>
                        </b-card>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" class="text-center buttonagregar">
                        <template v-if="!setUpdateItem">
                            <button class="btn btn-primary btnagregarstyle" v-if="validateFields()" @click="addItem()"><i class="fa fa-plus"></i> Agregar</button>
                            <button class="btn btn-secondary btnagregarstyle" disabled v-else><i class="fa fa-plus"></i> Agregar</button>
                        </template>
                        <template v-else>
                            <button class="btn btn-warning" @click="executeUpdate()"><i class="fa fa-plus"></i> Actualizar</button>
                        </template>
                    </b-col>
                </b-row>
                <br>
                <b-table responsive 
                    :small="small"
                    :items="items"
                    :fields="items_fields"
                    >
                    <template slot="index" slot-scope="row">{{ row.index +1 }}</template>
                    <template slot="acciones" slot-scope="row">
                        <b-row>
                            <button class="btn btn-sm btn-group btn-outline-primary acciones-espacio" @click.prevent="updateItem(row.index, row.item)"><i class="fa fa-edit primary"></i></button>
                            <button class="btn btn-sm btn-group btn-outline-danger" @click.prevent="deletePlusItem(row.index)"><i class="fa fa-trash danger"></i></button>
                        </b-row>
                    </template>
                </b-table>
                <hr>
                <b-row>
                    <b-col cols="12" sm="12"	md="6"	lg="7"	xl="8">
                            <div>
                            <b-btn block v-b-toggle.extras class="m-1 colorestelemovil">Extras</b-btn>
                            <b-collapse id="extras">
                                <b-card>
                                    <b-row>  
                                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="4">
                                            <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="formadepago">
                                                <option :value="fpago.codigo" v-for="fpago in formaPago" v-bind:key="fpago.codigo">
                                                    {{ fpago.nombre }}
                                                </option>
                                            </select>
                                        </b-col>
                                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="4">
                                            <b-form-group
                                                label-for="input_ordenCompra"
                                                :invalid-feedback="invalidFeedbackOrdenCompra"
                                                :valid-feedback="validFeedbackOrdenCompra"
                                                :state="stateOrdenCompra">
                                                <b-input-group size="md">
                                                    <b-form-input :value="ordenCompra" 
                                                        required 
                                                        @input="ordenCompra = $event.toUpperCase()" 
                                                        v-model="ordenCompra" 
                                                        minlength="1"
                                                        maxlength="20" 
                                                        class="form-control input-placedark input-dark" 
                                                        type="text" 
                                                        id="input_ordenCompra" 
                                                        :state="stateOrdenCompra" 
                                                        placeholder="Orden de Compra">
                                                    </b-form-input>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="4">
                                            <datepicker v-model="fvencimiento" :language="es" :format="customFormatter" :bootstrap-styling="true" placeholder="Fecha de Vencimiento"></datepicker>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </b-collapse>
                        </div>
                        <div>
                            <b-btn block v-b-toggle.adicionales class="m-1 colorestelemovil">Datos Adicionales</b-btn>
                            <b-collapse id="adicionales">
                                <b-card>
                                    <b-row>
                                        <b-col cols="12" sm="12"	md="12"	lg="4"	xl="5">
                                            <input type="text" placeholder="Nombre del Adicional" class="form-control input-placedark input-dark" v-model="key">
                                        </b-col>
                                        <b-col cols="12" sm="12"	md="12"	lg="4"	xl="5">
                                            <input type="text" placeholder="Valor del Adicional" class="form-control input-placedark input-dark" v-model="value">
                                        </b-col>
                                        <b-col cols="12" sm="12"	md="12"	lg="4"	xl="2">
                                            <button v-if="validateFieldsAdicionales()" class="btn btn-primary" @click="addAdicional"><i class="fa fa-plus"></i> Agregar</button>
                                            <button v-else class="btn btn-secondary" disabled><i class="fa fa-plus"></i> Agregar</button>
                                        </b-col>
                                    </b-row><br>
                                    <b-row>
                                        <b-table striped hover :items="items_adicionales" :fields="fields_adicionales">
                                            <template striped hover slot="acciones" slot-scope="row">
                                                <b-button-group>
                                                    <b-button title="Eliminar Adicional" @click="deleteAdicional(row.item)"><i class="fa fa-trash"></i></b-button>
                                                </b-button-group>
                                            </template>
                                        </b-table>
                                    </b-row>
                                </b-card>
                            </b-collapse>
                        </div>
                    </b-col>
                    <b-col cols="12" sm="12"	md="6"	lg="5"	xl="4">
                        <b-row>
                            <b-col>
                                <div class="text-center">
                                    <strong>TOTALES</strong>
                                </div>
                            </b-col>
                        </b-row>
                        <hr>
                        <b-row>
                            <b-col cols="6" sm="6"	md="6"	lg="6"	xl="6">
                                <div><strong>IGV:</strong></div>
                                <div><strong>Venta Gravada:</strong></div>
                                <div><strong>Venta Exonerada:</strong></div>
                                <div><strong>Venta Inafecta:</strong></div>
                                <div><strong>Venta Gratuita:</strong></div>
                                <!-- <div><strong>Descuentos:</strong></div> -->
                                <!-- <div><strong>Cargos:</strong></div> -->
                                <div><strong>Venta:</strong></div>
                            </b-col>
                            <b-col cols="2" sm="2"	md="2"	lg="2"	xl="2">
                                <div>
                                    {{ moneda.simbolo }}
                                </div>
                                <div>
                                    {{ moneda.simbolo }}
                                </div>
                                <div>
                                    {{ moneda.simbolo }}
                                </div>
                                <div>
                                    {{ moneda.simbolo }}
                                </div>
                                <div>
                                    {{ moneda.simbolo }}
                                </div>
                                <div>
                                    {{ moneda.simbolo }}
                                </div>
                            </b-col>
                            <b-col cols="4" sm="4"	md="4"	lg="4"	xl="4">
                                <div class="alineacionTotales">
                                    {{ accumulateIgvAdd() }}
                                </div>
                                <div class="alineacionTotales">
                                    {{ accumulateRecordedSaleAdd() }}
                                </div>
                                <div class="alineacionTotales">
                                    {{ accumulateExoneratedSaleAdd() }}
                                </div>
                                <div class="alineacionTotales">
                                    {{ accumulateUnaffectedSaleAdd() }}
                                </div>
                                <div class="alineacionTotales">
                                    {{ accumulateFreeSaleAdd() }}
                                </div>
                                <div class="alineacionTotales">
                                    {{ accumulateTotalSaleAdd() }}
                                </div>
                            </b-col>
                        </b-row>
                        <br>
                        <div class="row">
                            <div class="col-md-6"></div>
                            <div class="col-md-4">
                            <template v-if="validateTicket()">
                                <button v-if="!cargandoemision" class="btn btn-primary" @click.prevent="sendNCAddItems"><i class="fa fa-location-arrow"></i> Previsualizar</button>
                            </template>
                            <template v-else>
                                <button class="btn btn-secondary" disabled><i class="fa fa-send"></i> Previsualizar</button>
                            </template>
                            </div>
                        </div>                
                        </b-col>
                </b-row>
            </template>
        </template>
        <template v-else>
            <vista-pre-emison :documentPrev="CreditNote" :tipodoc="tipodoc" @preEmision="backEmision"></vista-pre-emison>
        </template>
        <template v-if="postEmision">
            <vista-post-emison @closePreview="closeModal" :idDocumentPreview="idDocumentPreview" :tipoDocPreview="tipoDocPreview"></vista-post-emison>
        </template> 
         <import  :itemsEx="itemsEx" :action="action" @totalitems="totalitems"></import>
        <div class="w-100">
                <em class="messageTipoNotaCredito" v-if="tiponotacredito == '01'">Usada cuando se produce una anulación total de la venta de bienes o la anulación total o parcial de los servicios no ejecutados. La anulación de la venta o servicios no ejecutados está condicionada a la correspondiente devolución de los bienes y de la retribución efectuada, cuando corresponda.</em>
                <em class="messageTipoNotaCredito" v-else-if="tiponotacredito == '03'">Usada para corregir un comprobante de pago electrónico que contenga una descripción que no corresponde al bien vendido o cedido en uso o al tipo de servicio prestado.</em>
                <em class="messageTipoNotaCredito" v-else-if="tiponotacredito == '04'">Usada cuando se aplique descuentos a los importes totales de una factura electrónica. No se permite la emisión de notas de crédito por descuentos globales tratándose de operaciones con consumidores finales, es decir descuentos sobre boletas de venta electrónica.</em>
                <em class="messageTipoNotaCredito" v-else-if="tiponotacredito == '05'">Motivo a utilizarse cuando se aplique descuentos a determinado(s) ítem(s) de una factura electrónica. No se permite la emisión de notas de crédito por descuentos por ítem tratándose de operaciones con consumidores finales, es decir descuentos sobre boletas de venta electrónica.</em>
                <em class="messageTipoNotaCredito" v-else-if="tiponotacredito == '06'">Cuando la emisión de la nota de crédito sea para documentar la devolución de los bienes facturados.</em>
                <em class="messageTipoNotaCredito" v-else-if="tiponotacredito == '07'">Cuando la emisión de la nota de crédito sea para documentar la devolución de parte de los bienes facturados, inclusive una devolución de una parte de la cantidad de los bienes consignados en una línea</em>
                <em class="messageTipoNotaCredito" v-else-if="tiponotacredito == '13'">Modificación de Cuotas y plazos</em>
        </div>
        <vue-snotify></vue-snotify>
    </b-card>
</template>

<script>
const config = {
    headers: {
        'Content-type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin':'*',
        'Access-Control-Allow-Methods': 'POST',
        'Access-Control-Allow-Headers':'*',
        'cache-control': 'no-cache'
        }
}
import axios from 'axios'
import { tiposNotaCreditoB } from '@/shared/utils'
import { DocumentosIdentidad } from '@/shared/utils'
import download from 'downloadjs'
import { Switch as cSwitch } from '@coreui/vue'
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
import { EspecificacionIgvTipo1 } from '@/shared/utils'
import { EspecificacionIgvTipo2 } from '@/shared/utils'
import { EspecificacionIgvTipo3 } from '@/shared/utils'
import { UnidadMedida } from '@/shared/utils'
import { TipoMoneda } from '@/shared/utils'
import { FormaPago } from '@/shared/utils'
import vistaPreEmision from '@/components/comunes/VistaPreEmision'
import vistaPostEmision from '@/components/comunes/VistaPostEmision'
import Import from '@/components/comunes/ItemsNC'
export default {
    // props: ['packageEmit'],
    name: 'NotaCreditoBoletaEmision',
    components: {
        Datepicker,
        cSwitch,
        Import,
        'vista-pre-emison': vistaPreEmision,
        'vista-post-emison': vistaPostEmision
    },
    data: () => {
        return {
            // Variables de Nota de Credito Boleta con items
            verDirecciones: false,
            direcciones: [],
            listaCorreos: [],
            sinresultados: false,
            closePreview: 0,
            tipoDocPreview: 0,
            postEmision: false,
            idDocumentPreview: 0,
            totalDescuentosAcumulados: '',
            preEmision: true,
            cantidad: 1,
            descripcion: '',
            precioVentaUnitario: '',
            valorUnitario: '',
            unidadMedidaCantidad: 'NIU',
            unidades: UnidadMedida,
            vunitario: false,
            checkcantidad: false,
            responsecheckcantidad: '',
            servicio: false,
            cargandoreceptor: false,
            documentosIdentidad: DocumentosIdentidad,
            placeholdercodigo: 'C. Sunat (*)',
            codigoProducto: '',
            codigoSunatBarras: '',
            logitudDoc: 12,
            cargandoCodBarras: false,
            cargandoBarrasSunat: false,
            switchitems: false,
            tipoDocumento: 0,
            listaDescription: [],
            listades: true,
            nodescription: false,
            loadDescription: false,
            listaReceptoresProductCode: [],
            listaReceptoresCodeBarrasSunat: [],
            listarecProduct: true,
            listarecProductBarrasSunat: true,
            norecProduct: false,
            norecProductBarrasSunat: false,
            listarecProductCode: false,
            labelTxt: {
                dataOn: 'Si',
                dataOff: 'No'
            },
            disabledTipoNC: false,
            monedaDisabled: true,
            tipodemoneda: {
                id: '1',
                codigo: 'PEN',
                descripcion: 'SOLES',
                simbolo: 'S/.'
            },
            tipoMoneda: TipoMoneda,
            moneda: {
                id: '1',
                codigo: 'PEN',
                descripcion: 'SOLES',
                simbolo: 'S/.'
            },
            items_adicionales: [],
            fields_adicionales: [
                {key: 'key', label: 'Clave', sorteable: true},
                {key: 'value', label: 'Valor', sorteable: true},
                {key: 'acciones', label: 'Acciones', sorteable: true},   
            ],
            itemAdicional: {
                key: '',
                value: ''
            },
            checkDescripcionNC: false,
            serieAfectada: '',
            checkSerieAfectada: false,
            responseSerieAfectado: '',
            numeroAfectado: '',
            checkNumeroAfectado: false,
            responseNumeroAfectado: '',
            descuentoItemMonto: '',
            descuentoItemPorcentaje: '',
            descuentoGlobalMonto: '',
            descuentoGlobalPorcentaje: '',
            otrosCargos: 0,
            ordenCompra: '',
            formadepago: '001',
            fvencimiento: '',
            key: '',
            value: '',
            small: true,
            vbarras: false,
            setUpdateItem: false,
            seriecon: '',
            numero: '',
            typeTicket: 1,
            habilitado: true,
            listaReceptores: [],
            show: true,
            adicional: {
                dirAlternativa: ''
            },
            listaSeries: [],
            setIndex: -1,
            cargandoreceptorNC: true,
            precioVentaUnitario: '',
            listarec: '',
            valorUnitario: '',
            tipoOperacion: '0101',
            formaPago: FormaPago,
            ventaGratuita: false,
            vunitario: false,
            checkprecioventaunitario: false,
            checkvalorunitario: false,
            tipodoc: '4',
            seriesCargadas: true,
            tabIndex: 2,
            emitiendo: false,
            validSetRow: false,
            descuento: true,
            montoDescuento: '',
            cargandoemisionCaso1: false,
            cargandoemisionCaso6: false,
            cargandoemisionCaso5: false,
            cargandoemisionCaso7: false,
            cargandoemisionCaso4: false,
            cargandoemisionCaso3: false,
            cargandoemisionCaso13: false,
            caso3Emitir: false,
            caso5Emitir: false,
            caso7Emitir: false,
            listaNotaCredito: [],
            listaNotaCreditoAfectada: [],
            descuentoItemSiguiente: false,
            checkPreview: false,
            preview: false,
            emisioncreditnote: false,
            cargandoemision: false,
            pdfobject: '',
            cargandopdf: false,
            cargandopdf2: false,
            descripcionNC: '',
            numeroAfectado: '',
            generalesNC: false,
            EspecificacionIgv: EspecificacionIgvTipo1, 
            EspecificacionIgv2: EspecificacionIgvTipo2, 
            EspecificacionIgv3: EspecificacionIgvTipo3, 
            modalsendnc: false,
            especificacionIgv: '01',
            afectacionIgv: '01',
            monto: '',
            igv: '',
            currentdate: '',
            es: es,
            femision: '',
            hemision: '',
            previanotacredito: false,
            previacorreo: false,
            sendcorreo: false,
            total: 0.00,
            desde: 0.00,
            hasta: 0.00,
            cargando: false,
            pactual: 1,
            limite: 10,
            orden: 'desc',
            recipients: '',
            serieNC: '',
            indexSerie: '0',
            listaafectacion: [
                {
                    id: '02',
                    descripcion: 'Inafecto'
                },
                {
                    id: '01',
                    descripcion: 'Gravado'
                },
                {
                    id: '03',
                    descripcion: 'Exonerado'
                },
            ],
            Especificacion: [],
            especificacion:{
                codigo: '10',
                descripcion: 'Operacion onerosa',
                codigoTributo: '1000'
            },
            creditnotes: [],
            creditnotesinvoice: [],
            creditnotes_fields: [
                {key: 'serie', label: 'Serie', sortable: true},
                {key: 'numero', label: 'Numero', sortable: true},
                {key: 'emision', label: 'Emision', sortable: true},
                {key: 'receptor', label: 'Receptor', sortable: true},
                {key: 'moneda', label: 'Total Gravado', sortable: true},
                {key: 'estado', label: 'Estado', sortable: true},
                {key: 'acciones', label: 'Acciones'}
            ],
            note: {},
            CreditNote: {
                token: '',
                serie: '',
                tipoNotaCredito: '',
                montoTotalImpuestos: '',
                totalVentaGravada: '',
                sumatoriaIgv: '',
                importeTotal: '',
                descripcion: '',
                tipoMoneda: '',
                serieAfectado: '',
                numeroAfectado: '',
                tipoComprobanteAfectado: '03',
                adicional: {
                    totalDescuentoItem: '',
                    dirAlternativa: '',
                    tipo_igv:'',
                },
                items: [],
                receptor: {
                    tipo: '',
                    nro: '',
                    razonSocial: '',
                    direccionFiscal: ''
                }
            },
            items: [],
            items_fields: [
                {key: 'index', label: 'Item'},
                {key: 'cantidad', label: 'Cantidad', sorteable: true},
                {key: 'descripcion', label: 'Descripción', sorteable: true},
                {key: 'valorUnitarioVista', label: 'Valor Unitario', sorteable: true},
                {key: 'descuento', label: 'Descuento', sorteable: true},
                {key: 'montoAfectacionIgv', label: 'Igv', sorteable: true},
                {key: 'valorVentaVista', label: 'Valor Total', sorteable: true},
                {key: 'acciones', label: 'Acciones', sorteable: true},
            ],
            creditnote: {},
            ticket: {},
            listaOtrosCargos: [],
            tiponotacredito: '01',
            tiposNotaCredito: tiposNotaCreditoB,
            diasnopermitidos: {
            ranges: []
            },
            montoTotalImpuestos: '',
            sumatoriaIgv: '',
            totalVentaGravada: '',
            totalVentaExonerada: '',
            importeTotal: '',
            sumatoriaOtrosCargos: '',
            totalVentaInafecta: '',

            previaEmisionCaso3:false,
            cambiarDescripcionn:'',
            juntar:'',
            itemTransitorio:[],
            descrip:'',
            validateSendCaso3: false,
            oldDescripcion:'',
            ncCredito:[],
            modalCredito:false,
            cuotasCredito:[],
            cuotas_credito:[
            {key:'identificadorCuota',label:'Cuotas'},
            {key:'fechaPagoCuota', label:'Fecha Vencimiento'},
            {key:'montoPagoCuota', label:'Monto',},      
            {key:'acciones', label:'Borrar'}
            ],
            totalcredito:0.0,
            fechaPagoCuota:'',
            montoPagoCuota:'',
            validarcredito:true,
            idencredito:'',
            importeTotalCuota:'',
            mostrarPreviaCreditos:false,
            previatipo13:true,
            itemsEx:[],
            action: {
                i: false,
                reset: false
            },
            unoDieciocho:1.18,
            ceroDieciocho:0.18,
            dieciocho:18,
            // unoUno:1.1,
            // ceroUno:0.1,
            // diez:10,
            unoUno:1.105,
            ceroUno:0.105,
            diez:10.5,
            igvGlobal:null,
        }
    },
    mounted () {
        this.initDates(),
        this.datesReference(),
        this.initIgv(),
        this.initNCDefault(),
        this.getSeries()
    },
    watch: {
        servicio: function (val) {
            if(this.servicio){
                this.unidadMedidaCantidad = 'ZZ'
            }else{
                this.unidadMedidaCantidad = 'NIU'
            }
        },
        cantidad: function () {
            if(this.cantidad < 0){
                this.checkcantidad = true
                this.responsecheckcantidad = 'Cantidad debe ser mayor a 0'
            }else{
                this.checkcantidad = false
                this.responsecheckcantidad = ''
            }         
        },
        seriecon: function () {
            if(this.seriecon.length != '' && this.serie.length != 4){
                this.checkseriecon = true
                this.responsecheckseriecon = 'Requerido 4 caracteres'
            }else{
                this.checkseriecon = false
                this.responsecheckseriecon = ''
            }
        },
        switchitems: function () {
            if(this.switchitems){
                this.disabledTipoNC = true,
                this.monedaDisabled = false
            }else{
                this.disabledTipoNC = false,
                this.monedaDisabled = true
            }
        },
        monto: function () {
            this.igv = parseFloat(this.monto / (this.$store.state.igv == 18 ? 1.18 : 1.105)).toFixed(2) //1.18
        },
        afectacionIgv: function () {
           if(this.afectacionIgv == '01'){
               this.Especificacion = this.especificacionIgv1
               this.especificacion = {
                    codigo: '10',
                    descripcion: 'Operacion onerosa',
                    codigoTributo: '1000'
                }
           }else{
               this.Especificacion = this.especificacionIgv2
               this.especificacion = {                
                    codigo: '30',
                    descripcion: 'Operación Onerosa',
                    codigoTributo: '9998'		
                }  
           } 
        },
        tiponotacredito: function () {
            if(this.tiponotacredito == '01' || this.tiponotacredito == '06' || this.tiponotacredito == '03' || this.tiponotacredito == '04' || this.tiponotacredito == '05' || this.tiponotacredito == '07' || this.tiponotacredito == '13'){
                this.generalesNC = true
                this.listaNotaCredito = [] 
                this.listaNotaCreditoAfectada = []
                this.items = []
                this.descuentoItemSiguiente = false
                this.mostrarPreviaCreditos = false
                this.previatipo13 = true
            }else{
                this.generalesNC = false
            }
        },
        precioVentaUnitario: function () {
            if(this.precioVentaUnitario < 0){
                this.checkprecioventaunitario = true
                this.responsecheckprecioventaunitario = 'Cantidad debe ser mayor a 0'
            }else{
                this.checkprecioventaunitario = false
                this.responsecheckprecioventaunitario = ''
            }
            if(this.especificacionIgv=='01'){
                if(!this.vunitario){
                this.valorUnitario = this.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
                }
            }
            else{
                this.valorUnitario = this.precioVentaUnitario
            }
        },
        valorUnitario: function () {
            if(this.valorUnitario < 0){
                this.checkvalorunitario = true
                this.responsecheckvalorunitario = 'Cantidad debe ser mayor a 0'
            }else{
                this.checkvalorunitario = false
                this.responsecheckvalorunitario = ''
            }
            if(this.vunitario)
            {
                if(this.especificacionIgv=='01'){
                this.precioVentaUnitario = this.valorUnitario * (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
                }
                else if(this.especificacionIgv=='02') {
                this.precioVentaUnitario = this.valorUnitario
                }
            }
        },
        ventaGratuita: function () {
            if(!this.ventaGratuita){
                this.especificacion.codigo = '10'
                this.especificacion.descripcion = 'Operacion onerosa'
                this.especificacion.codigoTributo = '1000'
            }else{
                this.especificacion.codigo = '15'
                this.especificacion.descripcion = 'Grabado - Bonificaciones'
                this.especificacion.codigoTributo = '9996'
            }
        },
        descripcion: function () {
            if(this.descripcion.length > 500){
                this.checkdescripcion = true
                this.responsecheckdescripcion = 'Alfanumerico de maximo 500 caracteres '
            }
            else if(this.descripcion.length == 0){
                this.sinresultados = false,
                this.listades = false,
                this.listaDescription = []
            }else{
                this.checkdescripcion = false
                this.responsecheckdescripcion = ''
            }
        },
        tipodemoneda: function () {
            this.moneda = this.tipodemoneda
        },
        servicio: function (val) {
            if(this.servicio){
                this.unidadMedidaCantidad = 'ZZ'
            }else{
                this.unidadMedidaCantidad = 'NIU'
            }
        },
        especificacionIgv: function () {
            if(!this.ventaGratuita){
                this.especificacion.codigo = '10'
                this.especificacion.descripcion = 'Operacion onerosa'
                this.especificacion.codigoTributo = '1000'
                this.calcItem()
            }else{
                this.especificacion.codigo = '15'
                this.especificacion.descripcion = 'Grabado - Bonificaciones'
                this.especificacion.codigoTributo = '9996'
                this.calcItemGratuitos()
            }
        },
        montoPagoCuota(){
            if(this.fechaPagoCuota !='' && this.montoPagoCuota > 0){
                this.validarcredito = false
            }else{
                this.validarcredito = true
            }
        },
        fechaPagoCuota(){
            if(this.fechaPagoCuota !='' && this.montoPagoCuota > 0){
                this.validarcredito = false
            }else{
                this.validarcredito = true
            }
        },
    },
    computed: {
        state () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serieNC.length == 0){

            } else if (!expreg.test(this.serieNC)) {
                return false
            } else if(this.serieNC.length == 3 ){
                return true
            }
        },
        invalidFeedback () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serieNC.length == 0) {
                return 'Ingresa una Serie'
            } else {
                return 'Minimo 3 caracteres'
            }
        },
        validFeedback () {
            return this.state === true ? 'Perfecto' : ''
        },
        stateSerieAfectada () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serieAfectada.length == 0){

            } else if (!expreg.test(this.serieAfectada)) {
                return false
            } else if(this.serieAfectada.length == 3 ){
                return true
            }
        },
        invalidFeedbackSerieAfectada () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serieAfectada.length == 0) {
                return 'Ingresa una Serie'
            } else {
                return 'Minimo 3 caracteres'
            }
        },
        validFeedbackSerieAfectada () {
            return this.stateSerieAfectada === true ? 'Perfecto' : ''
        },
        stateOrdenCompra () {
            let expreg = new RegExp("^[A-Z0-9]{1,20}$")
            if (this.ordenCompra.length == 0){

            } else if (!expreg.test(this.ordenCompra)) {
                return false
            } else if(this.ordenCompra.length < 20 ){
                return true
            }
        },
        invalidFeedbackOrdenCompra () {
            if (this.ordenCompra.length == 0) {
                return 'Ingresa una Orden de Compra'
            } else {
                return 'Caracter Invalido'
            }
        },
        validFeedbackOrdenCompra () {
            return this.stateOrdenCompra === true ? 'OC Valida' : ''
        }
    },
    methods: {
        cerrarresultados: function () {
            this.listaDescription = [],
            this.listades = false
        },
        closeModal: function (value) {
            if(value === 1){
                this.postEmision = true
            }else if(value === 2){
                this.postEmision = false
            }
        },
        backEmision(value) {
            if(value.idDocumento === 0){
                this.cargandoemision = false
                this.preEmision = true
                this.postEmision = false
                this.caso5Emitir = true
                this.caso7Emitir = true
                this.emitiendo = false
            }else if(value.idDocumento != 0){
                this.idDocumentPreview = value.idDocumento
                this.tipoDocPreview = value.tipoDoc
                this.cargandoemision = true
                this.preEmision = true
                this.postEmision = true
                this.initCreditNote()
            }
        },
        calcItem: function () {
            var parent = this;
            if(parent.especificacionIgv === '01' && !parent.vunitario){
                parent.Especificacion = parent.EspecificacionIgv
                parent.especificacion = {
                    codigo: '10',
                    descripcion: 'Operacion onerosa',
                    codigoTributo: '1000'
                }
                parent.valorUnitario = parent.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
            }
            else if(parent.especificacionIgv === '01' && parent.vunitario){
                parent.precioVentaUnitario = parent.valorUnitario * (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
                
            }
            else if(parent.especificacionIgv === '02' && !parent.vunitario){
                    parent.Especificacion = parent.EspecificacionIgv2
                    parent.especificacion = {                
                                codigo: '30',
                                descripcion: 'Operación Onerosa',
                                codigoTributo: '9998'		
                            }      
                    parent.valorUnitario = parent.precioVentaUnitario
            }
            else if(parent.especificacionIgv === '02' && parent.vunitario){
                    parent.precioVentaUnitario = parent.valorUnitario
            }
            else if(parent.especificacionIgv === '03' && !parent.vunitario){
                parent.Especificacion = parent.EspecificacionIgv3
                parent.especificacion = {                
                            codigo: '20',
                            descripcion: 'Operación Onerosa',
                            codigoTributo: '9997'		
                        }      
                parent.valorUnitario = parent.precioVentaUnitario
            }
            else if(parent.especificacionIgv === '03' && parent.vunitario){
                parent.precioVentaUnitario = parent.valorUnitario
            }

        },
        calcItemGratuitos: function () {
            var parent = this;
            if(parent.especificacionIgv === '01' && !parent.vunitario){
                parent.Especificacion = parent.EspecificacionIgv
                parent.especificacion = {
                    codigo: '15',
                    descripcion: 'Grabado - Bonificaciones',
                    codigoTributo: '9996'
                }
                parent.valorUnitario = parent.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
            }
            else if(parent.especificacionIgv === '01' && parent.vunitario){
                parent.precioVentaUnitario = parent.valorUnitario * (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
            }
            else if(parent.especificacionIgv === '02' && !parent.vunitario){
                    parent.Especificacion = parent.EspecificacionIgv2
                    parent.especificacion = {
                                codigo: '31',
                                descripcion: 'Retiro por Bonificación',
                                codigoTributo: '9996'
                            }
                    parent.valorUnitario = parent.precioVentaUnitario
            }
            else if(parent.especificacionIgv === '02' && parent.vunitario){
                    parent.precioVentaUnitario = parent.valorUnitario
            }
            else if(parent.especificacionIgv === '03' && !parent.vunitario){
                parent.Especificacion = parent.EspecificacionIgv3
                parent.especificacion = {
                            codigo: "21",
                            descripcion: "Transferencia gratuita",
                            codigoTributo: "9996"
                        }
                parent.valorUnitario = parent.precioVentaUnitario
            }
            else if(parent.especificacionIgv === '03' && parent.vunitario){
                parent.precioVentaUnitario = parent.valorUnitario
            }
        },
        setReceiver: function (item) {
            this.CreditNote.receptor.nro = item.idReceptor,
            this.CreditNote.receptor.tipo = item.tipo,
            this.CreditNote.receptor.razonSocial = item.razonSocial,
            this.CreditNote.receptor.direccionFiscal = item.direccionReferencia
            this.direcciones = item.direcciones,
            this.listaCorreos = item.email,
            this.listarec = false
            this.listaReceptores = []
        },
        setReceiverDescription: function (item) {
            this.codigoProducto = item.codigo,
            this.descripcion = item.descripcion,
            this.codigoSunatBarras = item.codigoProductoSunat,
            this.precioVentaUnitario = item.precioUnitario,
            this.unidadMedidaCantidad = item.unidadMedida
            if(item.tipoAfectacionIgv == ''){
                this.especificacionIgv = '01'
            }else{
                this.especificacionIgv = item.tipoAfectacionIgv
            }
            this.listades = false,
            this.listaDescription = []
        },
        getReceiversProductCode: function (value) {
            if(value.length>1){
               this.cargandoCodBarras = true
               this.listarecProduct = true
               this.norecProduct = false
               axios
                .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                    token: this.$store.getters.userToken,
                    filtro: 'code',
                    p: this.codigoProducto
                })
                .then(response => (
                    this.listaReceptoresProductCode = response.data.response,
                    this.cargandoCodBarras = false,
                    this.receivercountProduct(this.listaReceptoresProductCode.length)                                 
                ))
                .catch(function (error){
                    this.cargandoCodBarras = false
                })
            }  
        },
        getReceiversCodeBarrasSunat: function (value) {
            let receiver = ''
            if(this.vbarras){
                receiver = 'codegs1'
            }else{
                receiver = 'codesunat'
            }
            if(value.length>1){
               this.cargandoBarrasSunat = true
               this.listarecProductBarrasSunat = true
               this.norecProductBarrasSunat = false
               axios
                .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                    token: this.$store.getters.userToken,
                     // 'name, code, codesunat, codegs1'
                     // Parametro ej: Shoes -> sho    
                    filtro: receiver,
                    p: this.codigoSunatBarras
                })
                .then(response => (
                    this.listaReceptoresCodeBarrasSunat = response.data.response,
                    this.cargandoBarrasSunat = false,
                    this.receivercountBarrasSunat(this.listaReceptoresCodeBarrasSunat.length)                                 
                ))
                .catch(function (error){
                    this.cargandoBarrasSunat = false
                })
            }  
        },
        setReceiverCodeBarrasSunat: function (item) {
            this.codigoProducto = item.codigo,
            this.descripcion = item.descripcion,
            this.codigoSunatBarras = item.codigoProductoSunat,
            this.precioVentaUnitario = item.precioUnitario,
            this.unidadMedidaCantidad = item.unidadMedida
            if(item.tipoAfectacionIgv == ''){
                this.especificacionIgv = '01'
            }else{
                this.especificacionIgv = item.tipoAfectacionIgv
            }
            this.listarecProductBarrasSunat = false,
            this.listaReceptoresCodeBarrasSunat = []
        },
        getReceiversDescription: function () {
            this.listaDescription = []
            if(this.descripcion.length > 1 && !this.sinresultados){
            this.sinresultados = true,
            setTimeout(() => 
            this.loadDescription = true,
            this.listades = true,
            this.nodescription = false,
            axios
            .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                token: this.$store.getters.userToken,
                filtro: 'name',
                p: this.descripcion
            })
            .then(response => (
                this.listaDescription = response.data.response,
                this.loadDescription = false,
                this.sinresultados = false,
                this.receivercountDescription(this.listaDescription.length)
            ))
            .catch(error => (
                this.loadDescription = false,
                this.sinresultados = true
                // this.menssageErrorDescripcion(error.response.data)
            )) 
            , 200);
            }
        },
        enableFieldsReceptor: function () {
            this.habilitado = false
        },
        getReceivers: function (value) {
           if(value.length>3){
               this.cargandoreceptor = true
               this.listarec = true
               this.norec = false
               axios
                .post(process.env.VUE_APP_API_URL + 'receptores/lista',{
                    token: this.$store.getters.userToken,
                    q: value,
                    tipoRec: this.tipoDocumento
                })
                .then(response => (
                    this.listaReceptores = response.data,
                    this.cargandoreceptor = false,
                    this.receivercount(this.listaReceptores.length)                             
                ))
                .catch(error => (
                    this.cargandoreceptor = false
                ))
            }            
        },
        getReceiver: function (value) {
            if(value.length == 8){
                this.tipoDocumento = '1'
            }else if(value.length == 11){
                this.tipoDocumento = '6'
            }else { 
                this.tipoDocumento = '0'
            }
            axios
            .post(process.env.VUE_APP_API_URL + 'receptores/listaconterceros',{
            token: this.$store.getters.userToken,
            q: value,
            tipoRec: this.tipoDocumento
            })
            .then(response => (
                this.CreditNote.receptor.tipo = response.data[0].tipo,
                this.CreditNote.receptor.nro = response.data[0].idReceptor,
                this.CreditNote.receptor.razonSocial = response.data[0].razonSocial,
                this.CreditNote.receptor.direccionFiscal = response.data[0].direccionReferencia,
                this.CreditNote.adicional.dirAlternativa = response.data[0].direccionReferencia,
                this.CreditNote.direcciones = response.data[0].direcciones,
                this.CreditNote.correos = response.data[0].email
            ))
            .catch(error => {})
        },
        getSeries: function () {
            this.seriesCargadas = true,
            axios
            .post(process.env.VUE_APP_API_URL + 'usuario/series/'+ this.tipodoc, {
                token: this.$store.getters.userToken
            })
            .then(response => (
                this.listaSeries = response.data.data, 
                this.rolSeries = response.data.rol,
                this.seriesCargadas = false,
                this.igvGlobal = response.data.igv
                ))
            .catch(error => {})
        },
        addAdicional: function () {
           this.itemAdicional.key = this.key
           this.itemAdicional.value = this.value
           this.items_adicionales.push(this.itemAdicional) 
           this.itemAdicional = {}
           this.key = ''
           this.value = ''
        },
        deleteAdicional: function (value) {
            this.items_adicionales.splice(value,1)
        },
        addItem: function () {
            let item ={
                baseAfectacionIgv: '',
                adicional: {
                    descuentoItem: {}
                }
            }
            item.valorVentaSinAfectar = this.valorUnitario*this.cantidad
            item.tipoAfectacionIgv = this.especificacion.codigo
            if(this.tipoOperacion == '0200'){
                item.codigoTributo = '9995'
                item.tipoAfectacionIgv = '40'
            }else{
                item.codigoTributo = this.especificacion.codigoTributo
            }
            if(this.codigoProducto != ''){
                item.codigoProducto = this.codigoProducto
            }
            if(!this.vbarras){
                item.codigoProductoSunat = this.codigoSunatBarras
            }else{
                item.codigoProductoGs1 = this.codigoSunatBarras
            }
            item.unidadMedidaCantidad = this.unidadMedidaCantidad
            item.cantidad = parseFloat(this.cantidad)
            item.descripcion = this.descripcion
            item.valorUnitario = parseFloat(this.valorUnitario).toFixed(10)

            if(this.especificacion.codigo == '10' || this.especificacion.codigo == '20' || this.especificacion.codigo == '30'){
                item.tipoPrecioVentaUnitario = '01'
            }
            else{
                item.tipoPrecioVentaUnitario = '02'
            }
            if(this.descuentoItemMonto != ''){
                item.descuento = parseFloat(this.descuentoItemMonto).toFixed(10) 
                item.porcentajeDescuento = parseFloat(this.descuentoItemMonto) / item.valorVentaSinAfectar
            }else if(this.descuentoItemPorcentaje != ''){
                item.descuento = ((this.descuentoItemPorcentaje)/100 * item.valorUnitario * item.cantidad).toFixed(10)
                item.porcentajeDescuento =this.descuentoItemPorcentaje / 100
            }else{
                item.descuento = (0.00).toFixed(10)
                delete item.adicional.descuentoItem
            }
            if(item.descuento == 0){
                item.baseAfectacionIgv = item.valorUnitario*item.cantidad
            }else{
                item.baseAfectacionIgv = item.valorUnitario*item.cantidad-item.descuento
            }
            if(this.ventaGratuita){
                item.valorUnitario = (0.00).toFixed(10)
                item.valorUnitarioVista = parseFloat(this.valorUnitario).toFixed(10)
                item.valorVenta = item.baseAfectacionIgv.toFixed(10)
                item.valorVentaVista = (0.00).toFixed(10)
            }else{
                item.valorUnitario = parseFloat(this.valorUnitario).toFixed(10)
                item.valorUnitarioVista = item.valorUnitario
                item.valorVenta = item.baseAfectacionIgv.toFixed(10)
                item.valorVentaVista = item.valorVenta
            }
            // item.valorVenta = item.baseAfectacionIgv.toFixed(10)
            if(this.especificacionIgv == '01'){               
                item.montoAfectacionIgv = (item.baseAfectacionIgv * (this.$store.state.igv == 18 ? 0.18 : 0.105)).toFixed(10) //0.18
                item.montoTotalImpuestosItem = item.montoAfectacionIgv
            }else if(this.especificacionIgv == '02'){
                item.montoAfectacionIgv = (0.00).toFixed(10)
                item.montoTotalImpuestosItem = item.montoAfectacionIgv
            }else if(this.especificacionIgv == '03'){
                item.montoAfectacionIgv = (0.00).toFixed(10)
                item.montoTotalImpuestosItem = item.montoAfectacionIgv
            }
            item.porcentajeImpuesto = (this.$store.state.igv == 18 ? 18 : 10.5); //18
            item.precioVentaUnitario = parseFloat(this.precioVentaUnitario)
            if(item.descuento != 0){
                item.adicional.descuentoItem.codigoMotivoDescuento = '01',
                item.adicional.descuentoItem.factorNumericoDescuento = parseFloat(item.porcentajeDescuento).toFixed(5)
                item.adicional.descuentoItem.montoDescuento = parseFloat(item.descuento).toFixed(2)
                item.adicional.descuentoItem.montoBaseDescuento = parseFloat(item.valorVentaSinAfectar).toFixed(2)
            }else{
                delete item.adicional.descuentoItem
            }
            if(this.setIndex != -1){
                Object.assign(this.items[this.setIndex], item)
                this.$snotify.warning('Item Actualizado Correctamente', 'Atencion'),
                this.setIndex = -1
                this.setUpdateItem = false
            }else{
                this.items.push(item)
            }
            this.cantidad = 1
            this.codigoProducto = ''
            this.codigoTributo = ''
            this.tipoAfectacionIgv = ''
            this.descripcion = ''
            this.precioVentaUnitario = ''
            this.valorUnitario = ''
            this.codigoSunatBarras = ''
            this.descuentoItemMonto = ''
            this.descuentoItemPorcentaje = ''
            this.descuento = true
            this.unidadMedidaCantidad = 'NIU'
            this.ventaGratuita = false
            item = {
                baseAfectacionIgv: '',
                adicional: {
                    descuentoItem: {}
                }
            }
        },
        updateItem: function (index, itemUpdate) {
            let itemChange = itemUpdate
            let item = {}
            this.setUpdateItem = true
            this.setIndex = index
            this.cantidad = itemChange.cantidad
            this.unidadMedidaCantidad = itemChange.unidadMedidaCantidad
            this.codigoProducto = itemChange.codigoProducto
            this.codigoSunatBarras = itemChange.codigoSunatBarras
            this.descripcion = itemChange.descripcion
            this.precioVentaUnitario = itemChange.precioVentaUnitario
            this.valorUnitario = itemChange.valorUnitario
        },
        executeUpdate: function () {
            this.addItem()
        },
        validateTicket: function () {
            let tiposerie = ''
            if(this.typeTicket == 1){
                if(this.indexSerie == 0){
                    this.serie = this.listaSeries[0]
                    tiposerie = this.serie
                }else{
                    this.serie = this.listaSeries[this.serie]
                    tiposerie = this.serie
                }
            }else if(this.typeTicket == 2){
                tiposerie = this.seriecon
            }
            if(tiposerie!==''  && this.items.length>0 && !this.seriesCargadas && this.serieAfectada !='' && this.numeroAfectado !=''){
                if(this.tipoDocumento == 1){
                    if(this.CreditNote.receptor.nro !='' && this.CreditNote.receptor.razonSocial !=''){
                         return true
                    }   
                }else{
                    return true
                }
            }else{
                return false
            }
        },
        validateFields: function () {
            if(this.tipoOperacion == '0200'){
                if(this.codigoSunatBarras == ''){
                return false
                }else{
                return true
                }
            }else{
                if(this.cantidad!='' && this.descripcion!='' && this.precioVentaUnitario!==''){
                return true
                }else{
                return false
                }
            }
        },
        validateFieldsGuia: function () {
            if(this.seriedeguia!='' && this.numerodeguia!='' && this.tipodeguia!==''){
                return true
            }else{
                return false
            }
        },
        validateFieldsAdicionales: function () {
            if(this.key!='' && this.value!=''){
                return true
            }else{
                return false
            }
        },
        accumulateIgvAdd: function () {
            let val = 0.00
            let valGratuita = 0.00
            this.items.forEach(function(element) {
                if(element.codigoTributo == '9996' && element.tipoPrecioVentaUnitario == '02'){
                valGratuita += parseFloat(element.montoAfectacionIgv);
                }else{
                val += parseFloat(element.montoAfectacionIgv);
                }
            });
            this.montoTotalImpuestos = val,
            this.sumatoriaIgv = val,
            this.sumatoriaIgvGratuitas = valGratuita
            return parseFloat(val).toFixed(2)
        },
        accumulateTaxesAdd: function () {
            var val = 0.00
            this.items.forEach(function(element) {
                val += parseFloat(element.montoAfectacionIgv);
            });
            this.sumatoriaIgv = parseFloat(val).toFixed(2)
            },
        accumulateRecordedSaleAdd: function () {
            var val = 0.00
            this.items.forEach(function(element) {
                if(element.tipoAfectacionIgv == '10'){
                val += parseFloat(element.valorVenta);
                }
            });
            this.totalVentaGravada = val
            return parseFloat(val).toFixed(2)

            },
        accumulateExoneratedSaleAdd: function () {
            var val = 0.00
            this.items.forEach(function(element) {
                if(element.tipoAfectacionIgv == '20'){
                val += parseFloat(element.valorVenta);
                }
            });
            this.totalVentaExonerada = val
            return parseFloat(val).toFixed(2)
            },
        accumulateUnaffectedSaleAdd: function () {
            var val = 0.00
            this.items.forEach(function(element) {
                if(element.tipoAfectacionIgv == '30'){
                val += parseFloat(element.valorVenta);
                }
            });
            this.totalVentaInafecta = val
            return parseFloat(val).toFixed(2)
            },
        accumulateFreeSaleAdd: function () {
            var val = 0.00
            this.items.forEach(function(element) {
                if(element.tipoAfectacionIgv == '11' ||
                element.tipoAfectacionIgv == '12' ||
                element.tipoAfectacionIgv == '13' ||
                element.tipoAfectacionIgv == '14' ||
                element.tipoAfectacionIgv == '15' ||
                element.tipoAfectacionIgv == '16' ||
                element.tipoAfectacionIgv == '31' ||
                element.tipoAfectacionIgv == '32' ||
                element.tipoAfectacionIgv == '33' ||
                element.tipoAfectacionIgv == '34' ||
                element.tipoAfectacionIgv == '35' ||
                element.tipoAfectacionIgv == '36' ||
                element.tipoAfectacionIgv == '21'
            ){
                val += parseFloat(element.valorVenta);
            }
            });
            this.totalVentaGratuita = val
            return parseFloat(val).toFixed(2)
        },
        accumulateOtrosCargos: function () {
            let val = 0.00
            if(this.tiponotacredito !='03' && this.tiponotacredito !='13'){
            this.listaOtrosCargos.forEach(function(element) {
                val += parseFloat(element.montoCargo);
            });
            }
            this.sumatoriaOtrosCargos = val
            return parseFloat(val).toFixed(2)
        },
        accumulateTotalSaleAdd: function () {
            var val = 0.00
            if(this.totalVentaGravada != 0 || this.totalVentaInafecta != 0 || this.totalVentaExonerada != 0){
                val = this.montoTotalImpuestos + this.totalVentaGravada + this.totalVentaInafecta + this.totalVentaExonerada
            }else{
                val = 0
            }
            this.importeTotal = val
            return parseFloat(val).toFixed(2)
        },
        montoDetraccionCalcAdd: function () {
            let val = 0.00
            this.importeTotal = this.montoTotalImpuestos + this.totalVentaGravada + this.totalVentaInafecta + this.totalVentaExonerada
            this.montoDetraccion = this.importeTotal * parseFloat(this.detraccion.porcentajeDetraccion)/100
            val = this.montoDetraccion
            return val.toFixed(0)
        },
        accumulateDescuentoAdd: function () {
            var val = 0.00;
            this.items.forEach(function(element) {
            val += parseFloat(element.descuento);
            });
            this.totalDescuentosAcumulados = val
            return parseFloat(val).toFixed(2)
        },
        ValidateCaso4: function () {
           if(!this.seriesCargadas && this.serieAfectado != '' && this.numeroAfectado != '' && this.descripcionNC != '' && this.precioVentaUnitario > parseFloat(0.00)){
                return true
            }else{
                return false
            }
        },
        accumulateIgv: function () {
            let val = 0.00
            let valGratuita = 0.00
        if(this.tiponotacredito !='03' && this.tiponotacredito !='13'){
            this.listaNotaCreditoAfectada.forEach(function(element) {
                if(element.codigoTributo == '9996' && element.tipoPrecioVentaUnitario == '02'){
                valGratuita += parseFloat(element.montoAfectacionIgv);
                }else{
                val += parseFloat(element.montoAfectacionIgv);
                }
            });
        }
            this.montoTotalImpuestos = val,
            this.sumatoriaIgv = val,
            this.sumatoriaIgvGratuitas = valGratuita
        
            return parseFloat(val).toFixed(2)
        },
        accumulateTaxes: function () {
            var val = 0.00;
                this.listaNotaCreditoAfectada.forEach(function(element) {
                    val += parseFloat(element.montoAfectacionIgv);
            });
            this.sumatoriaIgv = val
        },
        accumulateRecordedSale: function () {
            var val = 0.00
        if(this.tiponotacredito !='03' && this.tiponotacredito !='13'){
            this.listaNotaCreditoAfectada.forEach(function(element) {
                if(element.tipoAfectacionIgv == '10'){
                val += parseFloat(element.valorVenta);
                }
            });
        }
            this.totalVentaGravada = val
            return parseFloat(val).toFixed(2)
        },
        accumulateExoneratedSale: function () {
            var val = 0.00
        if(this.tiponotacredito !='03' && this.tiponotacredito !='13'){
            this.listaNotaCreditoAfectada.forEach(function(element) {
                if(element.tipoAfectacionIgv == '20'){
                val += parseFloat(element.valorVenta);
                }
            });
        }
            this.totalVentaExonerada = val
            return parseFloat(val).toFixed(2)
        },
        accumulateUnaffectedSale: function () {
            var val = 0.00
            if(this.tiponotacredito !='03' && this.tiponotacredito !='13'){
            this.listaNotaCreditoAfectada.forEach(function(element) {
                if(element.tipoAfectacionIgv == '30'){
                val += parseFloat(element.valorVenta);
                }
            });
            }
            this.totalVentaInafecta = val
            return parseFloat(val).toFixed(2)
        },
        accumulateFreeSaleAdd: function () {
            var val = 0.00
            this.listaNotaCreditoAfectada.forEach(function(element) {
                if(element.tipoAfectacionIgv == '11' ||
                element.tipoAfectacionIgv == '12' ||
                element.tipoAfectacionIgv == '13' ||
                element.tipoAfectacionIgv == '14' ||
                element.tipoAfectacionIgv == '15' ||
                element.tipoAfectacionIgv == '16' ||
                element.tipoAfectacionIgv == '31' ||
                element.tipoAfectacionIgv == '32' ||
                element.tipoAfectacionIgv == '33' ||
                element.tipoAfectacionIgv == '34' ||
                element.tipoAfectacionIgv == '35' ||
                element.tipoAfectacionIgv == '36' ||
                element.tipoAfectacionIgv == '21'
            ){
                val += parseFloat(element.valorVenta);
            }
            });
            this.totalVentaGratuita = val
            return parseFloat(val).toFixed(2)
        },
        accumulateTotalSale: function () {
            var val = 0.00
            if(this.tiponotacredito !='03' && this.tiponotacredito !='13'){
                if(this.totalVentaGravada != 0 || this.totalVentaInafecta != 0 || this.totalVentaExonerada != 0 || this.sumatoriaOtrosCargos != 0){
                    val = this.montoTotalImpuestos + this.totalVentaGravada + this.totalVentaInafecta + this.totalVentaExonerada + this.sumatoriaOtrosCargos
                }else{
                    val = 0
                }
            }
            this.importeTotal = val
            return parseFloat(val).toFixed(2)
        },
        deleteItem: function (selected, value) {
            let item = {}
            item = selected
            this.$swal({
                title: 'Eliminar Item',
                text: 'Seguro de eliminar este item ???',
                icon: 'error',
                buttons: true,
                dangerMode: true
            }).then((willDelete) => {
                if(willDelete){
                    if(this.tiponotacredito == '05'){
                        item.valorUnitario = selected.oldValorUnitario
                        item.porcentajeDescuento = selected.oldPorcentajeDescuento
                        item.valorVenta = selected.oldValorVenta
                        item.baseAfectacionIgv = selected.oldBaseAfectacionIgv 
                        item.montoAfectacionIgv = selected.oldMontoAfectacionIgv
                        this.listaNotaCredito.push(item)
                        this.listaNotaCreditoAfectada.splice(value,1)
                        if(this.listaNotaCreditoAfectada.length == 0){
                            this.caso5Emitir = false
                        }
                    }else if(this.tiponotacredito == '07'){
                        item.cantidad = selected.oldCantidad
                        item.valorVenta = selected.oldValorVenta
                        item.baseAfectacionIgv = selected.oldBaseAfectacionIgv 
                        item.montoAfectacionIgv = selected.oldMontoAfectacionIgv
                        this.listaNotaCredito.push(item)
                        this.listaNotaCreditoAfectada.splice(value,1)
                        if(this.listaNotaCreditoAfectada.length == 0){
                            this.caso7Emitir = false
                        }
                    }else if(this.tiponotacredito =='03'){
                        item.descripcion = this.oldDescripcion
                        this.listaNotaCredito.push(item)
                        this.listaNotaCreditoAfectada.splice(value,1)
                    }
                }else{ }
            })
        },
        deletePlusItem: function (index) {
            this.$swal({
                title: 'Eliminar Item',
                text: 'Seguro de eliminar este item ???',
                icon: 'error',
                buttons: true,
                dangerMode: true
            }).then((willDelete) => {
                if(willDelete){
                    this.items.splice(index,1)
                }else
                {

                }
            })
        },
        setUnitValue: function () {
            let nuevoitem = this.itemAlterado
            nuevoitem.valorUnitario = this.montoDescuento / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
            nuevoitem.valorVenta = nuevoitem.valorUnitario * nuevoitem.cantidad
            if(this.itemAlterado.adicional == null){
                delete nuevoitem.adicional
            }
            this.listaNotaCreditoAfectada.push(nuevoitem)
        },
        datesReference: function () {
            this.fechareferencia = this.$moment().subtract(1,'days').format('YYYY-MM-DD')
        },
        initDates: function () {
            let r1 = {
                from: this.$moment().subtract(50000,'years'),
                to: this.$moment().subtract(4,'days')
            }
            let r2 = {
                from: this.$moment().add(0,'days'),
                to: this.$moment().add(60000,'years')
            }
            this.diasnopermitidos.ranges.push(r1)
            this.diasnopermitidos.ranges.push(r2)
            this.currentdate = this.$moment().format('YYYY-MM-DD HH:mm:ss')
        },
        initIgv: function () {
            if(this.especificacionIgv === '01'){
                this.Especificacion = this.especificacionIgv1
            }
            else if(this.especificacionIgv === '02'){
                this.Especificacion = this.especificacionIgv2
            }
        },
        initNCDefault: function () {
            this.generalesNC = true
            this.tiponotacredito = '01'
        },
        validateCreditNote: function () {
            if(this.descripcionNC != '' && this.tiponotacredito != '0' && !this.seriesCargadas){
                return true
            }
            else{
                return false
            }
        },
        verifyPreview: function () {
           if(this.ticket.estado == 310){
                this.cargandoemision = true
                this.sendNoteCredit()
            }else{
                this.searchTicket()
            }
        },
        searchTicket: function () {
            if(this.tiponotacredito == '01'){
                this.cargandoemisionCaso1 = true
            }else if(this.tiponotacredito == '06'){
                this.cargandoemisionCaso6 = true
            }else if(this.tiponotacredito == '05'){
                this.cargandoemisionCaso5 = true
            }else if(this.tiponotacredito == '07'){
                this.cargandoemisionCaso7 = true
            }else if(this.tiponotacredito == '04'){
                this.cargandoemisionCaso4 = true
            }else if(this.tiponotacredito == '03'){
                this.cargandoemisionCaso3 = true
            }else if(this.tiponotacredito == '13'){
                this.cargandoemisionCaso13 = true              
            }
            axios
            .post(process.env.VUE_APP_API_URL + 'boletas/obtener/detalles',{
                token: this.$store.getters.userToken,
                p: 'B' + this.serieAfectada + '-' + this.numeroAfectado,
                filtro: 'name'
            })
            .then(response => (
                this.validarBaja(response.data)
            ))
            .catch(error => (
                this.emisioncreditnote = false,
                this.cargandoemisionCaso1 = false,
                this.$snotify.error(error.response.data.msg,'Error')
            ))
        },
        validarBaja: function (data) {
            if(data.response.baja == 0){
                this.ticket = data
                this.redirectCreditNoteTipo(data)
            }else if(data.response.baja == 1){
                this.$snotify.error('No se puede emitir una Nota de Credito a una Boleta dada de baja!','Error')
            }
        },
        redirectCreditNoteTipo: function (value) {
            if(value.success == 1){
                this.listaNotaCredito = value.response.details
                if(value.response.adicional && value.response.adicional.cargosGlobal){
                    this.listaOtrosCargos = value.response.adicional.cargosGlobal
                }
                // Anulacion de la operación
                this.setMoneda()
                this.alertaSerie()
                if(this.tiponotacredito == '01'){
                    this.cargandoemisionCaso1 = false
                    this.addItemTipo1()
                // Correccion por error en la descripcion
                }else if(this.tiponotacredito == '03'){
                    this.cargandoemisionCaso3 = false
                    this.generalesNC = false
                    this.descuentoItemSiguiente = true
                // Descuento Global
                }else if(this.tiponotacredito == '04'){
                    this.generalesNC = true
                    this.addItemTipo4()
                // Descuento por item
                }else if(this.tiponotacredito == '05'){
                    this.cargandoemisionCaso5 = false
                    this.generalesNC = false
                    this.descuentoItemSiguiente = true
                // Devolucion Total
                }else if(this.tiponotacredito == '06'){
                    this.cargandoemisionCaso6 = false
                    this.addItemTipo1()
                // Devolucion parcial
                }else if(this.tiponotacredito == '07'){
                    this.cargandoemisionCaso7 = false
                    this.generalesNC = false
                    this.descuentoItemSiguiente = true
                }else if(this.tiponotacredito == '13'){
                    if(value.response.adicional.credito && value.response.adicional.credito.length > 0){
                        this.ncCredito = value.response.adicional.credito
                        this.importeTotalCuota = value.response.importeTotal
                        this.cargandoemisionCaso13 = false
                        this.mostrarPreviaCreditos = true
                        this.generalesNC = false
                        this.previatipo13 = false
                        this.itemsEx = this.listaNotaCredito
                        this.action.i = true 
                    }else{
                        this.$snotify.warning('El documento no cuenta con Créditos','Cuidado')
                        this.cargandoemisionCaso13 = false
                    }
                }
            }else{
                this.$snotify.error('La Boleta a la que quieres afectar no existe', 'Error'),
                this.initNCDefault(),
                this.descuentoItemSiguiente = false
            }
            
        },
        alertaSerie: function () {
            if(this.listaSeries.length == 0){
                this.$snotify.warning('Verifique que tenga una serie valida!', 'Cuidado')
            }
        },
        setMoneda: function () {
            var parent = this;
            let codigoMoneda = parent.ticket.tipoMoneda
            parent.tipoMoneda.forEach(function(element) {
                if(element.codigo === codigoMoneda){
                    parent.moneda.id = element.id,
                    parent.moneda.codigo = element.codigo,
                    parent.moneda.descripcion = element.descripcion,
                    parent.moneda.simbolo = element.simbolo
                }
            })
        },
        verifyTicket: function (value) {
            if(value.estado == 310){
                if(this.checkPreview){
                    axios
                    .post(process.env.VUE_APP_API_URL + 'boletas/pdf',{
                        token: this.$store.getters.userToken,
                        id: this.ticket.response.idBoleta
                    }, config)
                    .then(response => (
                        this.pdfobject = response.data.base64,
                        this.cargandopdf2 = false,
                        this.checkPreview = false
                        //    this.preview = false
                    ))
                    .catch(error => (
                        this.cargandopdf2 = true,
                        this.checkPreview = false,
                        //    this.preview = false,
                        this.$snotify.error('La boleta presenta errores!', 'Error')
                    ))
                }else{
                    this.sendNoteCredit()
                }
            }else{
                this.emisioncreditnote = true
                this.preview = false
                this.$snotify.error('La Boleta que quieres afectar no existe!', 'Error')
            }   
        },
        setTicket: function (data) {
            this.creditnote = data
        },
        sendMail: function (data) {
            this.previacorreo = true,
            this.sendcorreo = true,
            axios
            .post(process.env.VUE_APP_API_URL + 'notacredito/mail', {
                token: this.$store.getters.userToken,
                id: data.idNotaCredito,
                mail: this.recipients
            })
            .then(response => (
               this.sendcorreo = false,
               this.previacorreo = false,
               this.$snotify.success(response.data.message, 'Exito')
                ))
             .catch(error => (
                this.previacorreo = false,
                this.previacorreo = false,
                this.$snotify.error(error.response.data.response, 'Error')
            ))
        },
        emitCreditNote: function () {
            this.cargandoemision = true
            this.emisioncreditnote = true
            this.searchTicket()
        },
        viewPdf: function () {
            this.checkPreview = true
            this.preview = true
            this.cargandopdf2 = true
            this.searchTicket()
        },
        addItemTipo1: function () {
            this.items = []
            this.listaNotaCreditoAfectada = []
            let item = {
                unidadMedidaCantidad: '',
                cantidad: '',
                valorVenta: '',
                precioVentaUnitario: '',
                tipoPrecioVentaUnitario: '',
                montoTotalImpuestosItem: '',
                baseAfectacionIgv: '',
                montoAfectacionIgv: '',
                porcentajeImpuesto: '',
                tipoAfectacionIgv: '',
                codigoTributo: '',
                descripcion: '',
                valorUnitario: '',
                codigoProducto: '',
                codigoProductoSunat: ''
            }
            let nroitems = this.ticket.response.details.length
            for (let i = 0; i < nroitems; i++){
                item.unidadMedidaCantidad = this.ticket.response.details[i].unidadMedidaCantidad,
                item.cantidad = parseFloat(this.ticket.response.details[i].cantidad),
                item.valorVenta = parseFloat(this.ticket.response.details[i].valorVenta),
                item.precioVentaUnitario = parseFloat(this.ticket.response.details[i].precioVentaUnitario),
                item.tipoPrecioVentaUnitario = this.ticket.response.details[i].tipoPrecioVentaUnitario,
                item.montoTotalImpuestosItem = this.ticket.response.details[i].montoTotalImpuestosItem,
                item.baseAfectacionIgv = parseFloat(this.ticket.response.details[i].baseAfectacionIgv),
                item.montoAfectacionIgv = parseFloat(this.ticket.response.details[i].montoAfectacionIgv),
                item.porcentajeImpuesto = parseFloat(this.ticket.response.details[i].porcentajeImpuesto),
                item.tipoAfectacionIgv = this.ticket.response.details[i].tipoAfectacionIgv,
                item.codigoTributo = this.ticket.response.details[i].codigoTributo,
                item.descripcion = this.ticket.response.details[i].descripcion,
                item.valorUnitario = parseFloat(this.ticket.response.details[i].valorUnitario),
                item.codigoProducto = this.ticket.response.details[i].codigoProducto,
                item.codigoProductoSunat = this.ticket.response.details[i].codigoProductoSunat,
                this.listaNotaCreditoAfectada.push(item)
                item = {
                    unidadMedidaCantidad: '',
                    cantidad: '',
                    valorVenta: '',
                    precioVentaUnitario: '',
                    tipoPrecioVentaUnitario: '',
                    montoTotalImpuestosItem: '',
                    baseAfectacionIgv: '',
                    montoAfectacionIgv: '',
                    porcentajeImpuesto: '',
                    tipoAfectacionIgv: '',
                    codigoTributo: '',
                    descripcion: '',
                    valorUnitario: '',
                    codigoProducto: '',
                    codigoProductoSunat: ''
                }
            }
            this.sendNoteCredit()
        },
        addItemTipo4: function () {
            this.listaNotaCreditoAfectada = []
            let item = {}
            item.unidadMedidaCantidad = 'NIU'
            item.cantidad = 1
            item.valorVenta = this.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
            item.precioVentaUnitario = this.precioVentaUnitario
            item.montoTotalImpuestosItem = this.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
            item.baseAfectacionIgv = this.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
            item.montoAfectacionIgv = this.precioVentaUnitario - (this.precioVentaUnitario/(this.$store.state.igv == 18 ? 1.18 : 1.105)) //1.18
            item.tipoAfectacionIgv = this.especificacion.codigo
            item.codigoTributo = '1000'
            item.descripcion = this.descripcionNC
            item.valorUnitario = this.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
            if(this.especificacion.codigo == '10' || this.especificacion.codigo == '20' || this.especificacion.codigo == '30'){
                item.tipoPrecioVentaUnitario = '01'
            }
            else{
                item.tipoPrecioVentaUnitario = '02'
            }
            if(this.ventaGratuita){
                item.valorUnitario = (0.00).toFixed(10)
                item.valorVenta = item.baseAfectacionIgv.toFixed(10)
            }else{
                item.valorUnitario = parseFloat(this.valorUnitario).toFixed(10)
                item.valorVenta = item.baseAfectacionIgv.toFixed(10)
            }
            if(item.tipoAfectacionIgv == '20' || item.tipoAfectacionIgv == '30'){
                item.porcentajeImpuesto = parseFloat(0.00)
            }else{
                item.porcentajeImpuesto = (this.$store.state.igv == 18 ? 18 : 10.5); //18
            }
            if(this.especificacionIgv == '01'){
                item.montoAfectacionIgv = (item.baseAfectacionIgv * (this.$store.state.igv == 18 ? 0.18 : 0.105)).toFixed(10) //0.18
                item.montoTotalImpuestosItem = item.montoAfectacionIgv
            }else if(this.especificacionIgv == '02'){
                item.montoAfectacionIgv = (0.00).toFixed(10)
                item.montoTotalImpuestosItem = item.montoAfectacionIgv
            }else if(this.especificacionIgv == '03'){
                item.montoAfectacionIgv = (0.00).toFixed(10)
                item.montoTotalImpuestosItem = item.montoAfectacionIgv
            }
            this.listaNotaCreditoAfectada.push(item)
            this.sendNoteCredit()
            return true
        },
        setrowCaso5: function (value, i) {
            // this.listaNotaCreditoAfectada = []
            let selected = {
                adicional: value.adicional,
                baseAfectacionIgv: value.baseAfectacionIgv,
                cantidad: value.cantidad,
                codigoProducto: value.codigoProducto,
                codigoProductoGs1: value.codigoProductoGs1,
                codigoProductoSunat: value.codigoProductoSunat,
                codigoTributo: value.codigoTributo,
                descripcion: value.descripcion,
                descuento: value.descuento,
                idFactura: value.idFactura,
                idFacturaItem: value.idFacturaItem,
                montoAfectacionIgv: value.montoAfectacionIgv,
                montoTotalImpuestosItem: value.montoTotalImpuestosItem,
                porcentajeDescuento: value.porcentajeDescuento,
                porcentajeImpuesto: value.porcentajeImpuesto,
                precioVentaUnitario: value.precioVentaUnitario,
                tipoAfectacionIgv: value.tipoAfectacionIgv,
                tipoPrecioVentaUnitario: value.tipoPrecioVentaUnitario,
                unidadMedidaCantidad: value.unidadMedidaCantidad,
                valorUnitario: value.valorUnitario,
                valorVenta: value.valorVenta
            }   
            if((parseFloat(selected.descuento) <= parseFloat(selected.precioVentaUnitario)) && (parseFloat(selected.descuento) > 0.00)){
                if(selected.adicional == null || selected.adicional == '[]'){
                    delete selected.adicional
                }else{
                    selected.adicional = JSON.parse(value.adicional)
                }
                // valores anteriores
                selected.oldValorUnitario = selected.valorUnitario
                selected.oldPorcentajeDescuento = selected.porcentajeDescuento
                selected.oldValorVenta = selected.valorVenta
                selected.oldBaseAfectacionIgv = selected.baseAfectacionIgv
                selected.oldMontoAfectacionIgv = selected.montoAfectacionIgv
                // valores cambiados
                selected.valorUnitario = value.descuento/(this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
                selected.porcentajeDescuento = (selected.valorUnitario * 100) / value.valorUnitario
                selected.valorVenta = selected.valorUnitario * selected.cantidad
                selected.baseAfectacionIgv = selected.valorVenta
                if(selected.montoAfectacionIgv == 0){
                    selected.montoAfectacionIgv = 0
                }else{
                    selected.montoAfectacionIgv = selected.baseAfectacionIgv * (this.$store.state.igv == 18 ? 0.18 : 0.105); //0.18
                    selected.montoTotalImpuestosItem = selected.baseAfectacionIgv *(this.$store.state.igv == 18 ? 0.18 : 0.105); //0.18
                }
        
                this.listaNotaCreditoAfectada.push(selected)
                this.listaNotaCredito.splice(i,1)
                this.caso5Emitir = true
            }else{
                this.caso5Emitir = false
                this.$snotify.warning('El descuento no puede ser mayor al Precio Unitario ni cero', 'Cuidado')
            }
        },
        setrowCasoTres(value, i){
            // this.listaNotaCreditoAfectada = [] 
            this.cambiarDescripcionn = '' 
            this.descrip = value.descripcion
            this.juntar = ('DICE: ' + ' ' + this.descrip + ' ' + 'DEBE DECIR: ')             
            let selected = {
                    baseAfectacionIgv: 0,
                    cantidad: value.cantidad,
                    codigoProducto: value.codigoProducto,
                    codigoProductoGs1: value.codigoProductoGs1,
                    codigoProductoSunat: value.codigoProductoSunat,
                    codigoTributo: value.codigoTributo,
                    descripcion: value.descripcion,
                    descuento: value.descuento,
                    cambiarDescripcion: value.cambiarDescripcion,
                    descontarCantidad: value.descontarCantidad,
                    idBoleta: value.idBoleta,
                    idBoletaItem: value.idBoletaItem,
                    montoAfectacionIgv: 0,
                    montoTotalImpuestosItem: 0,
                    porcentajeDescuento: value.porcentajeDescuento,
                    porcentajeImpuesto: value.porcentajeImpuesto,
                    precioVentaUnitario: 0,
                    tipoAfectacionIgv: value.tipoAfectacionIgv,
                    tipoPrecioVentaUnitario: value.tipoPrecioVentaUnitario,
                    unidadMedidaCantidad: value.unidadMedidaCantidad,
                    valorUnitario: 0,
                    valorVenta: 0,
                    indexCaso3: i
                  
                }
                this.itemTransitorio.push(selected)
        },
        setrowCaso357: function (value, i) { 
            // this.listaNotaCreditoAfectada = [] 
            this.cambiarDescripcionn = '' 
            this.descrip = value.descripcion
            this.juntar = ('DICE: ' + ' ' + this.descrip + ' ' + 'DEBE DECIR: ')             
            let selected = {
                    adicional: value.adicional,
                    baseAfectacionIgv: value.baseAfectacionIgv,
                    cantidad: value.cantidad,
                    codigoProducto: value.codigoProducto,
                    codigoProductoGs1: value.codigoProductoGs1,
                    codigoProductoSunat: value.codigoProductoSunat,
                    codigoTributo: value.codigoTributo,
                    descripcion: value.descripcion,
                    descuento: value.descuento,
                    cambiarDescripcion: value.cambiarDescripcion,
                    descontarCantidad: value.descontarCantidad,
                    idBoleta: value.idBoleta,
                    idBoletaItem: value.idBoletaItem,
                    montoAfectacionIgv: value.montoAfectacionIgv,
                    montoTotalImpuestosItem: value.montoTotalImpuestosItem,
                    porcentajeDescuento: value.porcentajeDescuento,
                    porcentajeImpuesto: value.porcentajeImpuesto,
                    precioVentaUnitario: value.precioVentaUnitario,
                    tipoAfectacionIgv: value.tipoAfectacionIgv,
                    tipoPrecioVentaUnitario: value.tipoPrecioVentaUnitario,
                    unidadMedidaCantidad: value.unidadMedidaCantidad,
                    valorUnitario: value.valorUnitario,
                    valorVenta: value.valorVenta,
                    indexCaso3: i
                  
                }
                this.itemTransitorio.push(selected)

                /*if(this.tiponotacredito == '03'){
                    if(selected.cambiarDescripcion != ''){
                        if(selected.adicional == null || selected.adicional == '[]'){
                            delete selected.adicional
                        }
                        selected.descripcion = selected.cambiarDescripcion
                        this.listaNotaCreditoAfectada.push(selected)
                        this.listaNotaCredito.splice(this.itemTransitorio.indexCaso3,1)
                        this.caso3Emitir = true
                    }else{
                        this.$snotify.warning('La descripcion no puede estar vacia', 'Cuidado')
                    }
                }*/
                if(this.tiponotacredito == '05'){
                    if(parseFloat(selected.descuento) < parseFloat(selected.valorUnitario)){
                        if(selected.adicional == null || selected.adicional == '[]'){
                            delete selected.adicional
                        }
                        // valores anteriores
                        selected.oldValorUnitario = selected.valorUnitario
                        selected.oldPorcentajeDescuento = selected.porcentajeDescuento
                        selected.oldValorVenta = selected.valorVenta
                        selected.oldBaseAfectacionIgv = selected.baseAfectacionIgv
                        selected.oldMontoAfectacionIgv = selected.montoAfectacionIgv
                        // valores cambiados
                        selected.valorUnitario = value.descuento/(this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
                        selected.porcentajeDescuento = (selected.valorUnitario * 100) / value.valorUnitario
                        selected.valorVenta = selected.valorUnitario * selected.cantidad
                        selected.baseAfectacionIgv = selected.valorVenta
                        if(selected.montoAfectacionIgv == 0){
                            selected.montoAfectacionIgv = 0
                        }else{
                            selected.montoAfectacionIgv = selected.baseAfectacionIgv * (this.$store.state.igv == 18 ? 0.18 : 0.105); //0.18
                            selected.montoTotalImpuestosItem = selected.baseAfectacionIgv * (this.$store.state.igv == 18 ? 0.18 : 0.105); //0.18
                        }

                        this.listaNotaCreditoAfectada.push(selected)
                        this.listaNotaCredito.splice(i,1)
                        this.caso5Emitir = true
                    }else{
                        this.caso5Emitir = false
                        this.$snotify.warning('El descuento no puede ser mayor al Valor Unitario', 'Cuidado')
                    }
                }
                if(this.tiponotacredito == '07'){
                    if(parseFloat(selected.descontarCantidad) <= parseFloat(selected.cantidad)){
                        if(selected.adicional == null || selected.adicional == '[]'){
                            delete selected.adicional
                        }else{
                            selected.adicional = JSON.parse(value.adicional)
                        }
                        // valores anteriores
                        selected.oldCantidad = selected.cantidad
                        selected.oldValorVenta = selected.valorVenta
                        selected.oldBaseAfectacionIgv = selected.baseAfectacionIgv
                        selected.oldMontoAfectacionIgv = selected.montoAfectacionIgv
                        // valores cambiados
                        selected.cantidad = value.descontarCantidad
                        selected.valorVenta = selected.cantidad * selected.valorUnitario
                        selected.baseAfectacionIgv = selected.valorVenta
                        if(selected.montoAfectacionIgv == 0){
                            selected.montoAfectacionIgv = 0
                        }else{
                            selected.montoAfectacionIgv = selected.baseAfectacionIgv * (this.$store.state.igv == 18 ? 0.18 : 0.105); //0.18
                        }
                        this.listaNotaCreditoAfectada.push(selected)
                        this.listaNotaCredito.splice(i,1)
                        this.caso7Emitir = true
                    }else{
                        this.caso7Emitir = false
                        this.$snotify.warning('La cantidad ingresada no puede ser mayor a la actual', 'Cuidado')
                    }
                }
        },
        setrowCaso3(){
           this.previaEmisionCaso3 = false 
           if(this.cambiarDescripcionn !=''){
               if(this.itemTransitorio[0].adicional == null || this.itemTransitorio[0].adicional == '[]'){
                            delete this.itemTransitorio[0].adicional
                            }
                this.itemTransitorio[0].descripcion = (this.juntar + this.cambiarDescripcionn)
                this.oldDescripcion = this.descrip 
                this.listaNotaCreditoAfectada.push(this.itemTransitorio[0])
                this.listaNotaCredito.splice(this.itemTransitorio[0].indexCaso3,1)
                this.itemTransitorio.pop()
                this.caso3Emitir = true
           }else{
                this.$snotify.warning('La descripcion no puede estar vacia', 'Cuidado')
            }
           
        },
        sendNoteCredit: function () {
            this.CreditNote.token = this.$store.getters.userToken
            this.CreditNote.adicional.tipo_igv = this.igvGlobal
            if(this.indexSerie == 0){
                this.CreditNote.serie = this.listaSeries[0]
            }else{
                this.CreditNote.serie = this.listaSeries[this.indexSerie]
            }
            if(this.femision != ''){
                this.CreditNote.fechaEmision = this.femision
            }
            if(this.ticket.response.adicional && this.ticket.response.adicional.cargosGlobal){
                this.CreditNote.adicional.cargosGlobal = this.ticket.response.adicional.cargosGlobal
            }
            if(this.cuotasCredito.length > 0){
                this.CreditNote.adicional.credito = this.cuotasCredito
                this.CreditNote.adicional.montoPendientePagoCredito = this.totalcredito
            }
            this.CreditNote.tipoNotaCredito = this.tiponotacredito
            this.CreditNote.descripcion = this.descripcionNC
            this.CreditNote.tipoMoneda = this.ticket.response.tipoMoneda
            this.CreditNote.serieAfectado = 'B' + this.serieAfectada
            this.CreditNote.numeroAfectado = this.numeroAfectado
            this.CreditNote.idDocumentoAfectado = this.ticket.response.idBoleta
            this.getReceiver(this.ticket.response.idReceptor)
            if(this.ticket.response.idReceptor.length == 8){
                this.CreditNote.receptor.tipo = '1'
            }else{
                this.CreditNote.receptor.tipo = '0'
            }
            this.CreditNote.items = this.listaNotaCreditoAfectada
            this.CreditNote.sumatoriaIgv = this.accumulateIgv()
            this.CreditNote.montoTotalImpuestos = this.accumulateIgv()
            this.CreditNote.totalVentaGravada = this.accumulateRecordedSale()
            this.CreditNote.totalVentaExonerada = this.accumulateExoneratedSale()
            this.CreditNote.totalVentaInafecta = this.accumulateUnaffectedSale()
            this.CreditNote.totalVentaGratuita = this.accumulateFreeSaleAdd() //linea agregada nc gratuitas
            this.CreditNote.sumatoriaOtrosCargos = this.accumulateOtrosCargos()
            this.CreditNote.importeTotal = this.accumulateTotalSale()
            this.CreditNote.direcciones = this.direcciones
            this.CreditNote.email = this.listaCorreos
            this.cargandoemisionCaso1 = false,
            this.cargandoemisionCaso4 = false,
            this.cargandoemisionCaso5 = false,
            this.cargandoemisionCaso6 = false,
            this.caso3Emitir = false,
            this.caso5Emitir = false,
            this.caso7Emitir = false,
            this.preEmision = false,
            this.jsonPreEmision(this.CreditNote)
        },
        sendNCAddItems: function () {
            this.cargandoemision = true
            this.CreditNote.tipoOperacion = this.tipoOperacion
            this.CreditNote.tipoNotaCredito = this.tiponotacredito
            this.CreditNote.descripcion = this.descripcionNC
            this.CreditNote.token = this.$store.getters.userToken
            this.CreditNote.receptor.tipo = this.tipoDocumento.toString()
            this.CreditNote.serieAfectado = this.serieAfectada
            this.CreditNote.numeroAfectado = this.numeroAfectado
            if(this.tipoDocumento == 0){
                this.CreditNote.receptor.nro = '-'
            }else{
                this.CreditNote.receptor.nro = this.CreditNote.receptor.nro
            }  
            this.CreditNote.receptor.razonSocial = this.CreditNote.receptor.razonSocial
            this.CreditNote.receptor.direccionFiscal = this.CreditNote.receptor.direccionFiscal
            this.CreditNote.adicional.dirAlternativa = this.CreditNote.receptor.direccionFiscal
            if(this.typeTicket == 1){
                if(this.indexSerie == 0){
                    this.CreditNote.serie = this.listaSeries[0]
                }else{
                    this.CreditNote.serie = this.listaSeries[this.indexSerie]
                }
            }else{
                this.CreditNote.contingencia = this.contingencia
                this.CreditNote.serie = this.seriecon
                this.CreditNote.numero = this.numero
            }
            this.CreditNote.sumatoriaIgv = this.sumatoriaIgv
            this.CreditNote.montoTotalImpuestos = this.montoTotalImpuestos
            this.CreditNote.totalVentaGravada = this.totalVentaGravada
            this.CreditNote.totalVentaExonerada = this.totalVentaExonerada
            this.CreditNote.totalVentaInafecta = this.totalVentaInafecta
            this.CreditNote.sumatoriaOtrosCargos = this.sumatoriaOtrosCargos
            this.CreditNote.importeTotal = this.importeTotal
            if(this.items_adicionales){
                this.CreditNote.adicional.extras = this.items_adicionales
            }
            if(this.totalDescuentosAcumulados){
                this.CreditNote.adicional.totalDescuentoItem = this.totalDescuentosAcumulados
            }
            if(this.adicional.dirAlternativa != ''){
                this.CreditNote.adicional.dirAlternativa = this.adicional.dirAlternativa
            }
            if(this.formadepago != '000'){
                this.CreditNote.adicional.formaPago = this.formadepago
            }
            if(this.femision != ''){
                this.CreditNote.fechaEmision = this.$moment(this.femision).format('YYYY-MM-DD HH:mm:ss')
            }
            if(this.fvencimiento != ''){
                this.CreditNote.adicional.fechaVencimiento = this.$moment(this.fvencimiento).format('YYYY-MM-DD')
            }
            this.CreditNote.adicional.ordenCompra = this.ordenCompra,
            this.CreditNote.adicional.tipo_igv = this.igvGlobal,
            this.CreditNote.items = this.items,
            this.CreditNote.tipoMoneda = this.moneda.codigo,
            // Antes de emitir 
            this.cargandoemisionCaso1 = false,
            this.cargandoemisionCaso4 = false,
            this.cargandoemisionCaso5 = false,
            this.cargandoemisionCaso6 = false,
            this.caso3Emitir = false,
            this.caso5Emitir = false,
            this.caso7Emitir = false,
            this.preEmision = false,
            this.jsonPreEmision(this.CreditNote)
        },
        initCreditNote: function () {
            this.cargandoemision = false,
            this.cargandoemisionCaso1 = false,
            this.cargandoemisionCaso5 = false,
            this.cargandoemisionCaso7 = false,
            this.cargandoemisionCaso6 = false,
            this.cargandoemisionCaso4 = false,
            this.cargandoemisionCaso3 = false,
            this.caso3Emitir = false,
            this.caso5Emitir = false,
            this.caso7Emitir = false,
            this.descuentoItemSiguiente = false,
            this.serieAfectada = '',
            this.numeroAfectado = '',
            this.descripcionNC = '',
            this.adicional.dirAlternativa = '',
            this.serie = '',
            this.seriecon = '',
            this.tipoDocumento = 0,
            this.formadepago = '001',
            this.ordenCompra = '',
            this.items_guias = [],
            this.guiasRelacionada = [],
            this.seriedeguia = '',
            this.numerodeguia = '',
            this.tipodeguia = '09',
            this.items_adicionales = [],
            this.key = '',
            this.value = '',
            this.typeTicket = 1,
            this.items = [],
            this.tipodemoneda = {
                id: '1',
                codigo: 'PEN',
                descripcion: 'SOLES',
                simbolo: 'S/.'
            },
            this.precioVentaUnitario = 0,
            this.contingencia = false,
            this.tiponotacredito = '01',
            this.CreditNote = {
                token: '',
                serie: '',
                tipoNotaCredito: '',
                montoTotalImpuestos: '',
                totalVentaGravada: '',
                sumatoriaIgv: '',
                importeTotal: '',
                descripcion: '',
                tipoMoneda: '',
                serieAfectado: '',
                numeroAfectado: '',
                tipoComprobanteAfectado: '03',
                adicional: {
                    totalDescuentoItem: '',
                    dirAlternativa: ''
                },
                items: [],
                receptor: {
                    tipo: '',
                    nro: '',
                    razonSocial: '',
                    direccionFiscal: ''
                }
            },
            this.initNCCaso5()
        },
        initNCCaso5: function () {
            this.listaNotaCreditoAfectada = []
            this.cargandoemisionCaso5 = true
            this.generalesNC = true
            this.descuentoItemSiguiente = false
        },
        jsonPreEmision: function (value){
            this.$emit("jsonEmision", value);
        },
        customFormatter(date) {
            return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
        },
         modalCuotas(){
            this.modalCredito = true;
        },
        addcuota(index,value){
            let sumatotales = 0
            sumatotales = parseFloat(this.totalcredito) + parseFloat(this.montoPagoCuota)
            if(this.fechaPagoCuota !='' && this.montoPagoCuota > 0){
            if(this.importeTotalCuota >= parseFloat(this.montoPagoCuota)){
                if(this.importeTotalCuota >= sumatotales){
                let total = 0.0
                let cuota = {
                identificadorCuota:'',
                fechaPagoCuota:'',
                montoPagoCuota:'',
                } 
                cuota.identificadorCuota = this.numerador(this.cuotasCredito.length+1)
                cuota.fechaPagoCuota = this.$moment(this.fechaPagoCuota).format("YYYY-MM-DD"),
                cuota.montoPagoCuota = parseFloat(this.montoPagoCuota);
                this.cuotasCredito.push(cuota)
                this.cuotasCredito.forEach(function(element){
                total += parseFloat(element.montoPagoCuota);
                }) 
                this.totalcredito = total
                this.fechaPagoCuota = '',
                this.montoPagoCuota = ''
                }else{
                this.$snotify.warning('El monto no debe ser mayor al importe total del documento');
                sumatotales = 0
                }  
            }else{
                this.$snotify.warning('El monto no debe ser mayor al importe total del documento');
                sumatotales = 0
            }
            }
        },
        deletecuota(index){ 
            let totalarray =''
            totalarray = this.cuotasCredito.length+1
            this.renameident(index)
            this.cuotasCredito.splice(index, 1);

            let total = 0.0
            this.cuotasCredito.forEach(function(element){
            total += parseFloat(element.montoPagoCuota);
            }) 
            this.totalcredito = total
        },
        renameident(index){ 
            for (let i=0;i < this.cuotasCredito.length; i++) {
                if(i > index){
                this.cuotasCredito[i].identificadorCuota = this.numerador(i)
                }
            }
        },
        modalcredito(){
            this.modalCredito = false
        },
        numerador(value){
            let cuotanom = value
            let cadenacuota = ''
            if(cuotanom >=1 && cuotanom <=9){
                cadenacuota = 'Cuota00'+ String(cuotanom)
            }else if(cuotanom >=10 && cuotanom <=99){
                cadenacuota = 'Cuota0'+ String(cuotanom)
            }else if(cuotanom >=100 && cuotanom <=999){
                cadenacuota = 'Cuota'+ String(cuotanom)
            }
            return cadenacuota;
        },
        totalitems(value){
            this.listaNotaCreditoAfectada = value
            this.action.i = false
        },
    }
}
</script>

<style>
.messageTipoNotaCredito {
        color: #8d8d8d;
        font-size: 11px;
    }
.espacio {
    margin-left: 15px;
}
.cargaritemsPersonalizado{
    padding-top: 0.2px;    
}
.agregaritemsnew{
    margin-top: 5px;
    margin-left: 1px;
    width: 50px;
}
.botonesemitir{
  width: 125px;
  margin-left: 15px;
}
</style>